"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("depa").controller("DepasCtrl", DepasCtrl);

  function DepasCtrl($scope, $rootScope, $state, $controller, $timeout, moment, CustomersService, UsersService, OperatorsService, GroupsService, DepasService, DamagesService, CustomListsService, AgGridService, ModalService, EmailHistoryService, VehiclesService, SyncConfigsService, TelematicSyncConfigsService, TelematicsService, DEPA_FORM_URL, APP_URL, READ_SUMMARY_URL, ApiService) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "DepasCtrl";

    vm.activeTab = "tous";
    vm.withDepaSlot = false;

    vm.tutoIsActived = true;

    vm.events = [];

    vm.currentTab = "tab0";

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: DepasService,
      params: {
        editPage: "depas/depa"
      }
    });

    vm.defaultManagerLabel = $rootScope.defaultManagerLabel;

    vm.displayDriverInfo = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(row) {
        var user, typeVehicles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, usersEmailCc, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _id, name, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, groupId, telematics, telematicRows, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, telematic, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _telematic, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, key;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return UsersService.getById(row.driverId.replace("$", ""));

              case 2:
                user = _context.sent;
                _context.next = 5;
                return CustomersService.getNameById(user.customerId);

              case 5:
                user.customerName = _context.sent;

                if (!user.contract) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return CustomListsService.getNameByValue("typeContract", user.contract);

              case 9:
                _context.t0 = _context.sent;
                _context.next = 13;
                break;

              case 12:
                _context.t0 = "";

              case 13:
                user.contractName = _context.t0;
                _context.next = 16;
                return CustomListsService.getSelectArray("typeVehicleV2");

              case 16:
                typeVehicles = _context.sent;

                typeVehicles = typeVehicles.map(function (item) {
                  return { value: item.value, name: item.name.split(" (")[0] };
                });
                user.typeVehicleNames = [];

                if (!(user.typeVehicles && user.typeVehicles.length > 0)) {
                  _context.next = 40;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 23;

                _loop = function _loop() {
                  var typeVehicle = _step.value;

                  var typeVehicleData = typeVehicles.find(function (item) {
                    return item.value === typeVehicle;
                  });
                  if (typeVehicleData && typeVehicleData.name) {
                    user.typeVehicleNames.push(typeVehicleData.name.split(" (")[0]);
                  }
                };

                for (_iterator = user.typeVehicles[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _loop();
                }
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t1 = _context["catch"](23);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 32:
                _context.prev = 32;
                _context.prev = 33;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 35:
                _context.prev = 35;

                if (!_didIteratorError) {
                  _context.next = 38;
                  break;
                }

                throw _iteratorError;

              case 38:
                return _context.finish(35);

              case 39:
                return _context.finish(32);

              case 40:
                if (!user.other1ManagerId) {
                  _context.next = 46;
                  break;
                }

                _context.next = 43;
                return UsersService.getNameById(user.other1ManagerId);

              case 43:
                _context.t2 = _context.sent;
                _context.next = 47;
                break;

              case 46:
                _context.t2 = "";

              case 47:
                user.other1ManagerName = _context.t2;

                if (!user.other1ManagerId) {
                  _context.next = 54;
                  break;
                }

                _context.next = 51;
                return UsersService.getNameWithEmailById(user.other1ManagerId);

              case 51:
                _context.t3 = _context.sent;
                _context.next = 55;
                break;

              case 54:
                _context.t3 = "";

              case 55:
                user.other1ManagerNameWithEmail = _context.t3;

                if (!user.other2ManagerId) {
                  _context.next = 62;
                  break;
                }

                _context.next = 59;
                return UsersService.getNameById(user.other2ManagerId);

              case 59:
                _context.t4 = _context.sent;
                _context.next = 63;
                break;

              case 62:
                _context.t4 = "";

              case 63:
                user.other2ManagerName = _context.t4;

                if (!user.other2ManagerId) {
                  _context.next = 70;
                  break;
                }

                _context.next = 67;
                return UsersService.getNameWithEmailById(user.other2ManagerId);

              case 67:
                _context.t5 = _context.sent;
                _context.next = 71;
                break;

              case 70:
                _context.t5 = "";

              case 71:
                user.other2ManagerNameWithEmail = _context.t5;

                if (!user.fleetManagerId) {
                  _context.next = 78;
                  break;
                }

                _context.next = 75;
                return UsersService.getNameById(user.fleetManagerId);

              case 75:
                _context.t6 = _context.sent;
                _context.next = 79;
                break;

              case 78:
                _context.t6 = "";

              case 79:
                user.fleetManagerName = _context.t6;

                if (!user.fleetManagerId) {
                  _context.next = 86;
                  break;
                }

                _context.next = 83;
                return UsersService.getNameWithEmailById(user.fleetManagerId);

              case 83:
                _context.t7 = _context.sent;
                _context.next = 87;
                break;

              case 86:
                _context.t7 = "";

              case 87:
                user.fleetManagerNameWithEmail = _context.t7;

                if (!user.rhManagerId) {
                  _context.next = 94;
                  break;
                }

                _context.next = 91;
                return UsersService.getNameById(user.rhManagerId);

              case 91:
                _context.t8 = _context.sent;
                _context.next = 95;
                break;

              case 94:
                _context.t8 = "";

              case 95:
                user.rhManagerName = _context.t8;

                if (!user.rhManagerId) {
                  _context.next = 102;
                  break;
                }

                _context.next = 99;
                return UsersService.getNameWithEmailById(user.rhManagerId);

              case 99:
                _context.t9 = _context.sent;
                _context.next = 103;
                break;

              case 102:
                _context.t9 = "";

              case 103:
                user.rhManagerNameWithEmail = _context.t9;

                if (!user.qseManagerId) {
                  _context.next = 110;
                  break;
                }

                _context.next = 107;
                return UsersService.getNameById(user.qseManagerId);

              case 107:
                _context.t10 = _context.sent;
                _context.next = 111;
                break;

              case 110:
                _context.t10 = "";

              case 111:
                user.qseManagerName = _context.t10;

                if (!user.qseManagerId) {
                  _context.next = 118;
                  break;
                }

                _context.next = 115;
                return UsersService.getNameWithEmailById(user.qseManagerId);

              case 115:
                _context.t11 = _context.sent;
                _context.next = 119;
                break;

              case 118:
                _context.t11 = "";

              case 119:
                user.qseManagerNameWithEmail = _context.t11;

                if (!user.defaultManagerId) {
                  _context.next = 126;
                  break;
                }

                _context.next = 123;
                return UsersService.getNameById(user.defaultManagerId);

              case 123:
                _context.t12 = _context.sent;
                _context.next = 127;
                break;

              case 126:
                _context.t12 = "";

              case 127:
                user.managerName = _context.t12;

                if (!user.defaultManagerId) {
                  _context.next = 134;
                  break;
                }

                _context.next = 131;
                return UsersService.getNameWithEmailById(user.defaultManagerId);

              case 131:
                _context.t13 = _context.sent;
                _context.next = 135;
                break;

              case 134:
                _context.t13 = "";

              case 135:
                user.managerNameWithEmail = _context.t13;
                usersEmailCc = "";

                if (!(user.usersEmailsCcId && user.usersEmailsCcId.length > 0)) {
                  _context.next = 166;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 141;
                _iterator2 = user.usersEmailsCcId[Symbol.iterator]();

              case 143:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 152;
                  break;
                }

                _id = _step2.value;
                _context.next = 147;
                return UsersService.getNameById(_id);

              case 147:
                name = _context.sent;

                usersEmailCc = usersEmailCc + (usersEmailCc ? ", " : "") + name;

              case 149:
                _iteratorNormalCompletion2 = true;
                _context.next = 143;
                break;

              case 152:
                _context.next = 158;
                break;

              case 154:
                _context.prev = 154;
                _context.t14 = _context["catch"](141);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t14;

              case 158:
                _context.prev = 158;
                _context.prev = 159;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 161:
                _context.prev = 161;

                if (!_didIteratorError2) {
                  _context.next = 164;
                  break;
                }

                throw _iteratorError2;

              case 164:
                return _context.finish(161);

              case 165:
                return _context.finish(158);

              case 166:
                user.usersEmailCc = usersEmailCc;

                if (user.usersEmailCc.includes("Sorti de l'entreprise") || user.other1ManagerName.includes("Sorti de l'entreprise") || user.other2ManagerName.includes("Sorti de l'entreprise") || user.fleetManagerName.includes("Sorti de l'entreprise") || user.rhManagerName.includes("Sorti de l'entreprise") || user.qseManagerName.includes("Sorti de l'entreprise") || user.managerName.includes("Sorti de l'entreprise") || user.usersEmailCc.includes("Supprimé") || user.other1ManagerName.includes("Supprimé") || user.other2ManagerName.includes("Supprimé") || user.fleetManagerName.includes("Supprimé") || user.rhManagerName.includes("Supprimé") || user.qseManagerName.includes("Supprimé") || user.managerName.includes("Supprimé")) {
                  user.backgroundColor = "rgb(249, 246, 89, 0.5)"; // yellow
                  // "rgb(249, 105, 89, 0.5)" // red
                }

                user.active = !user.endDate || new Date(user.endDate) >= new Date() ? true : false;

                if (!(user.groupsId && user.groupsId.length > 0)) {
                  _context.next = 214;
                  break;
                }

                if (!(user.groupsId.length == 1)) {
                  _context.next = 182;
                  break;
                }

                user.groupId = user.groupsId[0];

                if (!user.groupId) {
                  _context.next = 178;
                  break;
                }

                _context.next = 175;
                return GroupsService.getNameById(user.groupId);

              case 175:
                _context.t15 = _context.sent;
                _context.next = 179;
                break;

              case 178:
                _context.t15 = "";

              case 179:
                user.groupName = _context.t15;
                _context.next = 212;
                break;

              case 182:
                if (!(user.groupsId.length > 1)) {
                  _context.next = 212;
                  break;
                }

                user.groupName = "";

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context.prev = 187;
                _iterator3 = user.groupsId[Symbol.iterator]();

              case 189:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context.next = 198;
                  break;
                }

                groupId = _step3.value;

                if (user.groupName) {
                  user.groupName += " | ";
                }
                _context.next = 194;
                return GroupsService.getNameById(groupId);

              case 194:
                user.groupName += _context.sent;

              case 195:
                _iteratorNormalCompletion3 = true;
                _context.next = 189;
                break;

              case 198:
                _context.next = 204;
                break;

              case 200:
                _context.prev = 200;
                _context.t16 = _context["catch"](187);
                _didIteratorError3 = true;
                _iteratorError3 = _context.t16;

              case 204:
                _context.prev = 204;
                _context.prev = 205;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 207:
                _context.prev = 207;

                if (!_didIteratorError3) {
                  _context.next = 210;
                  break;
                }

                throw _iteratorError3;

              case 210:
                return _context.finish(207);

              case 211:
                return _context.finish(204);

              case 212:
                _context.next = 215;
                break;

              case 214:
                user.groupName = "N.C.";

              case 215:

                if (user.positions) {
                  user.positions = user.positions.filter(function (item) {
                    if (item === $rootScope.rhManagerValue && $rootScope.rhManagerHidden) {
                      return false;
                    } else if (item === $rootScope.qseManagerValue && $rootScope.qseManagerHidden) {
                      return false;
                    } else if (item === $rootScope.fleetManagerValue && $rootScope.fleetManagerHidden) {
                      return false;
                    } else if (item === $rootScope.other1ManagerValue && $rootScope.other1ManagerHidden) {
                      return false;
                    } else if (item === $rootScope.other2ManagerValue && $rootScope.other2ManagerHidden) {
                      return false;
                    } else {
                      return true;
                    }
                  }).map(function (item) {
                    if (item === $rootScope.defaultManagerValue) {
                      item = $rootScope.defaultManagerLabel;
                    } else if (item === $rootScope.rhManagerValue) {
                      item = $rootScope.rhManagerLabel;
                    } else if (item === $rootScope.qseManagerValue) {
                      item = $rootScope.qseManagerLabel;
                    } else if (item === $rootScope.fleetManagerValue) {
                      item = $rootScope.fleetManagerLabel;
                    } else if (item === $rootScope.other1ManagerValue) {
                      item = $rootScope.other1ManagerLabel;
                    } else if (item === $rootScope.other2ManagerValue) {
                      item = $rootScope.other2ManagerLabel;
                    }
                    return item;
                  });
                }

                _context.next = 218;
                return TelematicsService.find({
                  filter: {
                    where: {
                      _driverId: row.driverId.replace("$", ""),
                      _customerId: $rootScope.$selectedCustomerId.replace("$", ""),
                      from: {
                        $gte: moment().startOf("month").subtract(3, "month").toDate(),
                        $lte: moment().toDate()
                      }
                    },
                    fields: {
                      _id: 1,
                      from: 1,
                      to: 1,
                      globalScore: 1,
                      _driverId: 1,
                      distanceTotal: 1,
                      durationTotal: 1,
                      fuelUsage: 1,
                      constantSpeedScore: 1,
                      drivingEventsScore: 1,
                      idlingScore: 1,
                      fuelUsageScore: 1,
                      coastingScore: 1,
                      greenSpeedScore: 1,
                      highRevvingScore: 1,
                      overSpeedScore: 1,
                      rolloutScore: 1,
                      wastedEnergyScore: 1,
                      harshBrakingScore: 1
                    },
                    order: { from: 1 }
                  }
                });

              case 218:
                telematics = _context.sent;
                telematicRows = [];

                if (!(telematics && telematics.length > 0)) {
                  _context.next = 240;
                  break;
                }

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context.prev = 224;

                for (_iterator4 = telematics[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  telematic = _step4.value;

                  telematicRows.push({
                    date: moment(telematic.from).format("-YY-MM"),
                    globalScore: typeof telematic.globalScore === "number" ? Math.round(telematic.globalScore * 1000) / 100 : null,
                    constantSpeedScore: typeof telematic.constantSpeedScore === "number" ? Math.round(telematic.constantSpeedScore * 1000) / 100 : null,
                    drivingEventsScore: typeof telematic.drivingEventsScore === "number" ? Math.round(telematic.drivingEventsScore * 1000) / 100 : null,
                    greenSpeedScore: typeof telematic.greenSpeedScore === "number" ? Math.round(telematic.greenSpeedScore * 1000) / 100 : null,
                    highRevvingScore: typeof telematic.highRevvingScore === "number" ? Math.round(telematic.highRevvingScore * 1000) / 100 : null,
                    overSpeedScore: typeof telematic.overSpeedScore === "number" ? Math.round(telematic.overSpeedScore * 1000) / 100 : null,
                    rolloutScore: typeof telematic.rolloutScore === "number" ? Math.round(telematic.rolloutScore * 1000) / 100 : null,
                    wastedEnergyScore: typeof telematic.wastedEnergyScore === "number" ? Math.round(telematic.wastedEnergyScore * 1000) / 100 : null,
                    harshBrakingScore: typeof telematic.harshBrakingScore === "number" ? Math.round(telematic.harshBrakingScore * 1000) / 100 : null,
                    idlingScore: typeof telematic.idlingScore === "number" ? Math.round(telematic.idlingScore * 1000) / 100 : null,
                    fuelUsageScore: typeof telematic.fuelUsageScore === "number" ? Math.round(telematic.fuelUsageScore * 1000) / 100 : null,
                    coastingScore: typeof telematic.coastingScore === "number" ? Math.round(telematic.coastingScore * 1000) / 100 : null,
                    distanceTotal: typeof telematic.distanceTotal === "number" ? telematic.distanceTotal / 1000 : null,
                    fuelUsagePer100Km: telematic.distanceTotal && typeof telematic.fuelUsage === "number" ? Math.round(telematic.fuelUsage / 1000 / (telematic.distanceTotal / 1000) * 100 * 100) / 100 : null
                  });
                }
                _context.next = 232;
                break;

              case 228:
                _context.prev = 228;
                _context.t17 = _context["catch"](224);
                _didIteratorError4 = true;
                _iteratorError4 = _context.t17;

              case 232:
                _context.prev = 232;
                _context.prev = 233;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 235:
                _context.prev = 235;

                if (!_didIteratorError4) {
                  _context.next = 238;
                  break;
                }

                throw _iteratorError4;

              case 238:
                return _context.finish(235);

              case 239:
                return _context.finish(232);

              case 240:
                if (!(telematicRows.length > 0)) {
                  _context.next = 285;
                  break;
                }

                user.withTelematic = true;
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context.prev = 245;
                _iterator5 = telematicRows[Symbol.iterator]();

              case 247:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context.next = 271;
                  break;
                }

                _telematic = _step5.value;
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context.prev = 252;

                for (_iterator6 = Object.keys(_telematic)[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  key = _step6.value;

                  user[key + "Telematic" + _telematic.date] = _telematic[key];
                }
                _context.next = 260;
                break;

              case 256:
                _context.prev = 256;
                _context.t18 = _context["catch"](252);
                _didIteratorError6 = true;
                _iteratorError6 = _context.t18;

              case 260:
                _context.prev = 260;
                _context.prev = 261;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 263:
                _context.prev = 263;

                if (!_didIteratorError6) {
                  _context.next = 266;
                  break;
                }

                throw _iteratorError6;

              case 266:
                return _context.finish(263);

              case 267:
                return _context.finish(260);

              case 268:
                _iteratorNormalCompletion5 = true;
                _context.next = 247;
                break;

              case 271:
                _context.next = 277;
                break;

              case 273:
                _context.prev = 273;
                _context.t19 = _context["catch"](245);
                _didIteratorError5 = true;
                _iteratorError5 = _context.t19;

              case 277:
                _context.prev = 277;
                _context.prev = 278;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 280:
                _context.prev = 280;

                if (!_didIteratorError5) {
                  _context.next = 283;
                  break;
                }

                throw _iteratorError5;

              case 283:
                return _context.finish(280);

              case 284:
                return _context.finish(277);

              case 285:
                _context.next = 287;
                return UsersService.displayInfo(user, vm.isAdmin, vm.isLvr, vm.isSuperAdmin, vm.syncConfig, vm.telematicSyncConfig, vm.softwareName);

              case 287:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[23, 28, 32, 40], [33,, 35, 39], [141, 154, 158, 166], [159,, 161, 165], [187, 200, 204, 212], [205,, 207, 211], [224, 228, 232, 240], [233,, 235, 239], [245, 273, 277, 285], [252, 256, 260, 268], [261,, 263, 267], [278,, 280, 284]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    vm.displayUserInfo = function (row) {
      ModalService.openComponent("user-info", {
        _id: row.driverId.replace("$", ""),
        size: "lg"
      }).then(function () {
        console.log("close modal");
      }).catch(function (err) {
        console.log("err", err);
      });
    };

    vm.openLastDepaForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var source;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              source = localStorage.getItem("last-depa-form");

              if (!source) {
                _context2.next = 5;
                break;
              }

              ModalService.openComponent("custom-iframe", {
                source: source,
                title: "Questionnaire DEPA",
                heightCalculationMethod: "bodyOffset",
                closeEvent: "mutationObserver",
                size: "lg",
                keyboard: false,
                withFooter: true
              }).then(function () {
                console.log("close modal");
                vm.refresh();
              }).catch(function (err) {
                console.error("err", err);
                vm.refresh();
              });
              _context2.next = 7;
              break;

            case 5:
              _context2.next = 7;
              return swal("", "Vous n'avez pas encore ouvert de questionnaire pour ce client.", "error");

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    vm.form = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var token, currentUserGroupIds, view, source;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return ApiService.getToken();

              case 2:
                token = _context3.sent;
                currentUserGroupIds = $rootScope.$user.groupsId;
                view = currentUserGroupIds.some(function (groupId) {
                  return groupId === "$633be6ad8a10010012815d87";
                }) ? "preventeur" : currentUserGroupIds.some(function (groupId) {
                  return groupId === "$65f2d6bf5075b5001298901a";
                }) ? "detaillee" : "standard";
                source = DEPA_FORM_URL + "/?id=" + row._id + "&shortId=" + row.shortId + "&token=" + token + "&trainingMode=false&view=" + view;

                localStorage.setItem("last-depa-form", source);
                ModalService.openComponent("custom-iframe", {
                  source: source,
                  title: "Questionnaire DEPA",
                  size: "lg",
                  keyboard: false,
                  heightCalculationMethod: "bodyOffset",
                  closeEvent: "mutationObserver",
                  withFooter: true
                }).then(function () {
                  console.log("close modal");
                  vm.refresh();
                }).catch(function (err) {
                  console.error("err", err);
                  vm.refresh();
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    vm.trainingForm = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var token, currentUserGroupIds, view, source;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return ApiService.getToken();

              case 2:
                token = _context4.sent;
                currentUserGroupIds = $rootScope.$user.groupsId;
                view = currentUserGroupIds.some(function (groupId) {
                  return groupId === "$633be6ad8a10010012815d87";
                }) ? "preventeur" : currentUserGroupIds.some(function (groupId) {
                  return groupId === "$65f2d6bf5075b5001298901a";
                }) ? "detaillee" : "standard";
                source = DEPA_FORM_URL + "/?id=" + row._id + "&shortId=" + row.shortId + "&token=" + token + "&trainingMode=true&view=" + view;

                localStorage.setItem("last-depa-form", source);
                ModalService.openComponent("custom-iframe", {
                  source: source,
                  title: "Mode Entrainement",
                  size: "lg",
                  keyboard: false,
                  heightCalculationMethod: "bodyOffset",
                  closeEvent: "mutationObserver",
                  color: "#97A164",
                  withFooter: true
                }).then(function () {
                  console.log("close modal");
                  vm.refresh();
                }).catch(function (err) {
                  console.error("err", err);
                  vm.refresh();
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();

    vm.reactivateDepa = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(depa) {
        var willInform, status, response, updatedDepa;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return swal({
                  //title: "",
                  text: "Le DEPA a \xE9t\xE9 pr\xE9c\xE9demment annul\xE9. Voulez-vous le r\xE9activer ?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                    cancel: "Non",
                    confirm: "Oui"
                  }
                });

              case 2:
                willInform = _context5.sent;

                if (!(willInform == true)) {
                  _context5.next = 28;
                  break;
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                status = "Nouveau à programmer";
                _context5.prev = 6;
                _context5.next = 9;
                return DepasService.updateAttributesById(depa._id, {
                  status: status,
                  meetingCancel: null,
                  reasonCancel: null,
                  reasonCancelDetails: null,
                  manuallyReactivated: true
                });

              case 9:
                response = _context5.sent;

                if (response._id) {
                  _context5.next = 14;
                  break;
                }

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context5.abrupt("return");

              case 14:
                Notiflix.Loading.remove();
                _context5.next = 22;
                break;

              case 17:
                _context5.prev = 17;
                _context5.t0 = _context5["catch"](6);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context5.abrupt("return");

              case 22:
                _context5.next = 24;
                return vm.refresh();

              case 24:
                updatedDepa = vm.rawData.find(function (item) {
                  return item._id === depa._id;
                });

                if (!(!row.missingCount || row.missingCount < 3)) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 28;
                return vm.scheduleDepa(updatedDepa);

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this, [[6, 17]]);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }();

    vm.scheduleDepa = function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(row) {
        var depa, schedule, oldEmailToUse, oldPhoneToUse, emails, customer, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, position, manager, _manager, _manager2, _manager3, _manager4, _manager5, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, leadId, lead, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, drmRespId, drmResp, _manager6, _manager7, managerN2, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, userId, user, _customer, nextReminder, _emails, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _position, _manager8, _manager9, _manager10, _manager11, _manager12, _manager13, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _leadId, _lead, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, _drmRespId, _drmResp, _manager14, _manager15, _managerN, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, _userId, _user, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, _position2, _manager16, _manager17, _manager18, _manager19, _manager20, _manager21, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, _leadId2, _lead2, _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, _drmRespId2, _drmResp2, _manager22, _manager23, _managerN2, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, _userId2, _user2, container, buttonText, text, button, confirmSend, allowSave, phoneMobileRegex, emailRegex, _iteratorNormalCompletion19, _didIteratorError19, _iteratorError19, _iterator19, _step19, email, values, response;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                depa = angular.copy(row);


                depa.emailToUse = depa.emailToUse ? depa.emailToUse.replace(/\s+/g, "") : null;

                _context8.prev = 2;

                if (!(depa.status === "Effectué")) {
                  _context8.next = 9;
                  break;
                }

                _context8.next = 6;
                return vm.openPdf(depa);

              case 6:
                return _context8.abrupt("return");

              case 9:
                if (!(depa.status === "Annulé" && !vm.isSuper)) {
                  _context8.next = 14;
                  break;
                }

                _context8.next = 12;
                return swal("", "Ce DEPA a été annulé.", "info");

              case 12:
                _context8.next = 653;
                break;

              case 14:
                if (!(depa.missingCount && depa.missingCount >= 3 && !vm.isSuper)) {
                  _context8.next = 19;
                  break;
                }

                _context8.next = 17;
                return swal("", "Le RDV a été manqué " + depa.missingCount + " fois. La prise de RDV se fait désormais uniquement en contactant le support (02 41 59 00 00 ou support@lvr-fleet.fr).", "warning");

              case 17:
                _context8.next = 653;
                break;

              case 19:
                schedule = function () {
                  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(depa) {
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return ModalService.openComponent("schedule-depa", {
                              _id: depa._id,
                              size: "lg",
                              keyboard: true,
                              driver: depa.driver,
                              typeOfAccident: depa.typeOfAccident,
                              shortId: depa.shortId,
                              phone: depa.phone,
                              note: depa.note,
                              slot: depa.slot,
                              phoneToUse: depa.phoneToUse,
                              emailToUse: depa.emailToUse,
                              scheduleUserName: depa.scheduleUserName,
                              damageManagerId: depa.managerId,
                              depaStatus: depa.status,
                              depaMissingCount: depa.missingCount
                            });

                          case 2:
                            vm.refresh(); // refreshed in case the appointment is chosen via the app

                          case 3:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));

                  return function schedule(_x6) {
                    return _ref7.apply(this, arguments);
                  };
                }();

                if (!(depa.status === "Annulé")) {
                  _context8.next = 212;
                  break;
                }

                oldEmailToUse = depa.emailToUse;
                oldPhoneToUse = depa.phoneToUse;
                emails = [];

                depa.phoneToUse = null;

                _context8.next = 27;
                return CustomersService.getById($rootScope.$selectedCustomerId);

              case 27:
                customer = _context8.sent;

                if (!customer.reminderByPositionCancel) {
                  _context8.next = 178;
                  break;
                }

                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context8.prev = 32;
                _iterator7 = customer.reminderByPositionCancel[Symbol.iterator]();

              case 34:
                if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                  _context8.next = 164;
                  break;
                }

                position = _step7.value;

                if (!(position === "Conducteur")) {
                  _context8.next = 41;
                  break;
                }

                if (depa.driver.cellularPhone) {
                  depa.phoneToUse = depa.driver.cellularPhone;
                }
                if (depa.driver.email) {
                  emails.push(depa.driver.email);
                }
                _context8.next = 161;
                break;

              case 41:
                if (!(position === "Manageur")) {
                  _context8.next = 48;
                  break;
                }

                _context8.next = 44;
                return UsersService.getById(depa.driver.defaultManagerId);

              case 44:
                manager = _context8.sent;

                if (manager && manager.email) {
                  emails.push(manager.email);
                }
                _context8.next = 161;
                break;

              case 48:
                if (!(position === "RH")) {
                  _context8.next = 55;
                  break;
                }

                _context8.next = 51;
                return UsersService.getById(depa.driver.rhManagerId);

              case 51:
                _manager = _context8.sent;

                if (_manager && _manager.email) {
                  emails.push(_manager.email);
                }
                _context8.next = 161;
                break;

              case 55:
                if (!(position === "QSE")) {
                  _context8.next = 62;
                  break;
                }

                _context8.next = 58;
                return UsersService.getById(depa.driver.qseManagerId);

              case 58:
                _manager2 = _context8.sent;

                if (_manager2 && _manager2.email) {
                  emails.push(_manager2.email);
                }
                _context8.next = 161;
                break;

              case 62:
                if (!(position === "Gestionnaire Parc")) {
                  _context8.next = 69;
                  break;
                }

                _context8.next = 65;
                return UsersService.getById(depa.driver.fleetManagerId);

              case 65:
                _manager3 = _context8.sent;

                if (_manager3 && _manager3.email) {
                  emails.push(_manager3.email);
                }
                _context8.next = 161;
                break;

              case 69:
                if (!(position === "Autre responsable 1")) {
                  _context8.next = 76;
                  break;
                }

                _context8.next = 72;
                return UsersService.getById(depa.driver.other1ManagerId);

              case 72:
                _manager4 = _context8.sent;

                if (_manager4 && _manager4.email) {
                  emails.push(_manager4.email);
                }
                _context8.next = 161;
                break;

              case 76:
                if (!(position === "Autre responsable 2")) {
                  _context8.next = 83;
                  break;
                }

                _context8.next = 79;
                return UsersService.getById(depa.driver.other2ManagerId);

              case 79:
                _manager5 = _context8.sent;

                if (_manager5 && _manager5.email) {
                  emails.push(_manager5.email);
                }
                _context8.next = 161;
                break;

              case 83:
                if (!(position === "LEAD" && customer._leadIds && customer._leadIds.length)) {
                  _context8.next = 114;
                  break;
                }

                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                _context8.prev = 87;
                _iterator8 = customer._leadIds[Symbol.iterator]();

              case 89:
                if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                  _context8.next = 98;
                  break;
                }

                leadId = _step8.value;
                _context8.next = 93;
                return UsersService.getById(leadId);

              case 93:
                lead = _context8.sent;

                if (lead && lead.email) {
                  emails.push(lead.email);
                }

              case 95:
                _iteratorNormalCompletion8 = true;
                _context8.next = 89;
                break;

              case 98:
                _context8.next = 104;
                break;

              case 100:
                _context8.prev = 100;
                _context8.t0 = _context8["catch"](87);
                _didIteratorError8 = true;
                _iteratorError8 = _context8.t0;

              case 104:
                _context8.prev = 104;
                _context8.prev = 105;

                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }

              case 107:
                _context8.prev = 107;

                if (!_didIteratorError8) {
                  _context8.next = 110;
                  break;
                }

                throw _iteratorError8;

              case 110:
                return _context8.finish(107);

              case 111:
                return _context8.finish(104);

              case 112:
                _context8.next = 161;
                break;

              case 114:
                if (!(position === "Responsable DRM" && customer._drmRespIds && customer._drmRespIds.length)) {
                  _context8.next = 145;
                  break;
                }

                _iteratorNormalCompletion9 = true;
                _didIteratorError9 = false;
                _iteratorError9 = undefined;
                _context8.prev = 118;
                _iterator9 = customer._drmRespIds[Symbol.iterator]();

              case 120:
                if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
                  _context8.next = 129;
                  break;
                }

                drmRespId = _step9.value;
                _context8.next = 124;
                return UsersService.getById(drmRespId);

              case 124:
                drmResp = _context8.sent;

                if (drmResp && drmResp.email) {
                  emails.push(drmResp.email);
                }

              case 126:
                _iteratorNormalCompletion9 = true;
                _context8.next = 120;
                break;

              case 129:
                _context8.next = 135;
                break;

              case 131:
                _context8.prev = 131;
                _context8.t1 = _context8["catch"](118);
                _didIteratorError9 = true;
                _iteratorError9 = _context8.t1;

              case 135:
                _context8.prev = 135;
                _context8.prev = 136;

                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }

              case 138:
                _context8.prev = 138;

                if (!_didIteratorError9) {
                  _context8.next = 141;
                  break;
                }

                throw _iteratorError9;

              case 141:
                return _context8.finish(138);

              case 142:
                return _context8.finish(135);

              case 143:
                _context8.next = 161;
                break;

              case 145:
                if (!(position === "Responsable du suivi")) {
                  _context8.next = 152;
                  break;
                }

                _context8.next = 148;
                return UsersService.getById(depa.managerId);

              case 148:
                _manager6 = _context8.sent;

                if (_manager6 && _manager6.email) {
                  emails.push(_manager6.email);
                }
                _context8.next = 161;
                break;

              case 152:
                if (!(position === "N+2")) {
                  _context8.next = 161;
                  break;
                }

                _context8.next = 155;
                return UsersService.getById(depa.driver.defaultManagerId);

              case 155:
                _manager7 = _context8.sent;

                if (!(_manager7 && _manager7.defaultManagerId)) {
                  _context8.next = 161;
                  break;
                }

                _context8.next = 159;
                return UsersService.getById(_manager7.defaultManagerId);

              case 159:
                managerN2 = _context8.sent;

                if (managerN2 && managerN2.email) {
                  emails.push(managerN2.email);
                }

              case 161:
                _iteratorNormalCompletion7 = true;
                _context8.next = 34;
                break;

              case 164:
                _context8.next = 170;
                break;

              case 166:
                _context8.prev = 166;
                _context8.t2 = _context8["catch"](32);
                _didIteratorError7 = true;
                _iteratorError7 = _context8.t2;

              case 170:
                _context8.prev = 170;
                _context8.prev = 171;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 173:
                _context8.prev = 173;

                if (!_didIteratorError7) {
                  _context8.next = 176;
                  break;
                }

                throw _iteratorError7;

              case 176:
                return _context8.finish(173);

              case 177:
                return _context8.finish(170);

              case 178:
                if (!customer.reminderByUserCancel) {
                  _context8.next = 207;
                  break;
                }

                _iteratorNormalCompletion10 = true;
                _didIteratorError10 = false;
                _iteratorError10 = undefined;
                _context8.prev = 182;
                _iterator10 = customer.reminderByUserCancel[Symbol.iterator]();

              case 184:
                if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                  _context8.next = 193;
                  break;
                }

                userId = _step10.value;
                _context8.next = 188;
                return UsersService.getById(userId);

              case 188:
                user = _context8.sent;

                if (user && user.email) {
                  emails.push(user.email);
                }

              case 190:
                _iteratorNormalCompletion10 = true;
                _context8.next = 184;
                break;

              case 193:
                _context8.next = 199;
                break;

              case 195:
                _context8.prev = 195;
                _context8.t3 = _context8["catch"](182);
                _didIteratorError10 = true;
                _iteratorError10 = _context8.t3;

              case 199:
                _context8.prev = 199;
                _context8.prev = 200;

                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                  _iterator10.return();
                }

              case 202:
                _context8.prev = 202;

                if (!_didIteratorError10) {
                  _context8.next = 205;
                  break;
                }

                throw _iteratorError10;

              case 205:
                return _context8.finish(202);

              case 206:
                return _context8.finish(199);

              case 207:
                if (customer.reminderByEmailPhoneToUseCancel) {
                  if (oldEmailToUse) {
                    emails.push(oldEmailToUse);
                  }
                  if (oldPhoneToUse) {
                    depa.phoneToUse = oldPhoneToUse;
                  }
                }

                // remove duplicates
                emails = emails.filter(function (item, index) {
                  return emails.indexOf(item) === index;
                });

                depa.emailToUse = emails.join(",");
                _context8.next = 584;
                break;

              case 212:
                _context8.next = 214;
                return CustomersService.getById($rootScope.$selectedCustomerId);

              case 214:
                _customer = _context8.sent;
                nextReminder = "1";

                if (depa.emailReminderDate2) {
                  nextReminder = "3";
                } else if (depa.emailReminderDate1) {
                  nextReminder = "2";
                }

                _emails = [];


                if (_customer["reminderByEmailPhoneToUseReport"]) {
                  if (depa.emailToUse) {
                    _emails.push(depa.emailToUse);
                  }
                }
                depa.phoneToUse = _customer["reminderByEmailPhoneToUseReport"] ? depa.phoneToUse : null;

                if (!_customer["reminderByPositionReport"]) {
                  _context8.next = 370;
                  break;
                }

                _iteratorNormalCompletion11 = true;
                _didIteratorError11 = false;
                _iteratorError11 = undefined;
                _context8.prev = 224;
                _iterator11 = _customer["reminderByPositionReport"][Symbol.iterator]();

              case 226:
                if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                  _context8.next = 356;
                  break;
                }

                _position = _step11.value;

                if (!(_position === "Conducteur")) {
                  _context8.next = 233;
                  break;
                }

                if (depa.driver.cellularPhone && (!_customer["reminderByEmailPhoneToUse" + nextReminder] || !depa.phoneToUse)) {
                  depa.phoneToUse = depa.driver.cellularPhone;
                }
                if (depa.driver.email) {
                  _emails.push(depa.driver.email);
                }
                _context8.next = 353;
                break;

              case 233:
                if (!(_position === "Manageur")) {
                  _context8.next = 240;
                  break;
                }

                _context8.next = 236;
                return UsersService.getById(depa.driver.defaultManagerId);

              case 236:
                _manager8 = _context8.sent;

                if (_manager8 && _manager8.email) {
                  _emails.push(_manager8.email);
                }
                _context8.next = 353;
                break;

              case 240:
                if (!(_position === "RH")) {
                  _context8.next = 247;
                  break;
                }

                _context8.next = 243;
                return UsersService.getById(depa.driver.rhManagerId);

              case 243:
                _manager9 = _context8.sent;

                if (_manager9 && _manager9.email) {
                  _emails.push(_manager9.email);
                }
                _context8.next = 353;
                break;

              case 247:
                if (!(_position === "QSE")) {
                  _context8.next = 254;
                  break;
                }

                _context8.next = 250;
                return UsersService.getById(depa.driver.qseManagerId);

              case 250:
                _manager10 = _context8.sent;

                if (_manager10 && _manager10.email) {
                  _emails.push(_manager10.email);
                }
                _context8.next = 353;
                break;

              case 254:
                if (!(_position === "Gestionnaire Parc")) {
                  _context8.next = 261;
                  break;
                }

                _context8.next = 257;
                return UsersService.getById(depa.driver.fleetManagerId);

              case 257:
                _manager11 = _context8.sent;

                if (_manager11 && _manager11.email) {
                  _emails.push(_manager11.email);
                }
                _context8.next = 353;
                break;

              case 261:
                if (!(_position === "Autre responsable 1")) {
                  _context8.next = 268;
                  break;
                }

                _context8.next = 264;
                return UsersService.getById(depa.driver.other1ManagerId);

              case 264:
                _manager12 = _context8.sent;

                if (_manager12 && _manager12.email) {
                  _emails.push(_manager12.email);
                }
                _context8.next = 353;
                break;

              case 268:
                if (!(_position === "Autre responsable 2")) {
                  _context8.next = 275;
                  break;
                }

                _context8.next = 271;
                return UsersService.getById(depa.driver.other2ManagerId);

              case 271:
                _manager13 = _context8.sent;

                if (_manager13 && _manager13.email) {
                  _emails.push(_manager13.email);
                }
                _context8.next = 353;
                break;

              case 275:
                if (!(_position === "LEAD" && _customer._leadIds && _customer._leadIds.length)) {
                  _context8.next = 306;
                  break;
                }

                _iteratorNormalCompletion12 = true;
                _didIteratorError12 = false;
                _iteratorError12 = undefined;
                _context8.prev = 279;
                _iterator12 = _customer._leadIds[Symbol.iterator]();

              case 281:
                if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
                  _context8.next = 290;
                  break;
                }

                _leadId = _step12.value;
                _context8.next = 285;
                return UsersService.getById(_leadId);

              case 285:
                _lead = _context8.sent;

                if (_lead && _lead.email) {
                  _emails.push(_lead.email);
                }

              case 287:
                _iteratorNormalCompletion12 = true;
                _context8.next = 281;
                break;

              case 290:
                _context8.next = 296;
                break;

              case 292:
                _context8.prev = 292;
                _context8.t4 = _context8["catch"](279);
                _didIteratorError12 = true;
                _iteratorError12 = _context8.t4;

              case 296:
                _context8.prev = 296;
                _context8.prev = 297;

                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                  _iterator12.return();
                }

              case 299:
                _context8.prev = 299;

                if (!_didIteratorError12) {
                  _context8.next = 302;
                  break;
                }

                throw _iteratorError12;

              case 302:
                return _context8.finish(299);

              case 303:
                return _context8.finish(296);

              case 304:
                _context8.next = 353;
                break;

              case 306:
                if (!(_position === "Responsable DRM" && _customer._drmRespIds && _customer._drmRespIds.length)) {
                  _context8.next = 337;
                  break;
                }

                _iteratorNormalCompletion13 = true;
                _didIteratorError13 = false;
                _iteratorError13 = undefined;
                _context8.prev = 310;
                _iterator13 = _customer._drmRespIds[Symbol.iterator]();

              case 312:
                if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
                  _context8.next = 321;
                  break;
                }

                _drmRespId = _step13.value;
                _context8.next = 316;
                return UsersService.getById(_drmRespId);

              case 316:
                _drmResp = _context8.sent;

                if (_drmResp && _drmResp.email) {
                  _emails.push(_drmResp.email);
                }

              case 318:
                _iteratorNormalCompletion13 = true;
                _context8.next = 312;
                break;

              case 321:
                _context8.next = 327;
                break;

              case 323:
                _context8.prev = 323;
                _context8.t5 = _context8["catch"](310);
                _didIteratorError13 = true;
                _iteratorError13 = _context8.t5;

              case 327:
                _context8.prev = 327;
                _context8.prev = 328;

                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                  _iterator13.return();
                }

              case 330:
                _context8.prev = 330;

                if (!_didIteratorError13) {
                  _context8.next = 333;
                  break;
                }

                throw _iteratorError13;

              case 333:
                return _context8.finish(330);

              case 334:
                return _context8.finish(327);

              case 335:
                _context8.next = 353;
                break;

              case 337:
                if (!(_position === "Responsable du suivi")) {
                  _context8.next = 344;
                  break;
                }

                _context8.next = 340;
                return UsersService.getById(depa.managerId);

              case 340:
                _manager14 = _context8.sent;

                if (_manager14 && _manager14.email) {
                  _emails.push(_manager14.email);
                }
                _context8.next = 353;
                break;

              case 344:
                if (!(_position === "N+2")) {
                  _context8.next = 353;
                  break;
                }

                _context8.next = 347;
                return UsersService.getById(depa.driver.defaultManagerId);

              case 347:
                _manager15 = _context8.sent;

                if (!(_manager15 && _manager15.defaultManagerId)) {
                  _context8.next = 353;
                  break;
                }

                _context8.next = 351;
                return UsersService.getById(_manager15.defaultManagerId);

              case 351:
                _managerN = _context8.sent;

                if (_managerN && _managerN.email) {
                  _emails.push(_managerN.email);
                }

              case 353:
                _iteratorNormalCompletion11 = true;
                _context8.next = 226;
                break;

              case 356:
                _context8.next = 362;
                break;

              case 358:
                _context8.prev = 358;
                _context8.t6 = _context8["catch"](224);
                _didIteratorError11 = true;
                _iteratorError11 = _context8.t6;

              case 362:
                _context8.prev = 362;
                _context8.prev = 363;

                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                  _iterator11.return();
                }

              case 365:
                _context8.prev = 365;

                if (!_didIteratorError11) {
                  _context8.next = 368;
                  break;
                }

                throw _iteratorError11;

              case 368:
                return _context8.finish(365);

              case 369:
                return _context8.finish(362);

              case 370:
                if (!_customer["reminderByUserReport"]) {
                  _context8.next = 399;
                  break;
                }

                _iteratorNormalCompletion14 = true;
                _didIteratorError14 = false;
                _iteratorError14 = undefined;
                _context8.prev = 374;
                _iterator14 = _customer["reminderByUserReport"][Symbol.iterator]();

              case 376:
                if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
                  _context8.next = 385;
                  break;
                }

                _userId = _step14.value;
                _context8.next = 380;
                return UsersService.getById(_userId);

              case 380:
                _user = _context8.sent;

                if (_user && _user.email) {
                  _emails.push(_user.email);
                }

              case 382:
                _iteratorNormalCompletion14 = true;
                _context8.next = 376;
                break;

              case 385:
                _context8.next = 391;
                break;

              case 387:
                _context8.prev = 387;
                _context8.t7 = _context8["catch"](374);
                _didIteratorError14 = true;
                _iteratorError14 = _context8.t7;

              case 391:
                _context8.prev = 391;
                _context8.prev = 392;

                if (!_iteratorNormalCompletion14 && _iterator14.return) {
                  _iterator14.return();
                }

              case 394:
                _context8.prev = 394;

                if (!_didIteratorError14) {
                  _context8.next = 397;
                  break;
                }

                throw _iteratorError14;

              case 397:
                return _context8.finish(394);

              case 398:
                return _context8.finish(391);

              case 399:

                console.log("emails", _emails);

                // If no emails found, try to use the next reminder settings

                if (_emails.length) {
                  _context8.next = 582;
                  break;
                }

                if (_customer["reminderByEmailPhoneToUse" + nextReminder] && depa.emailToUse) {
                  _emails.push(depa.emailToUse);
                }
                depa.phoneToUse = _customer["reminderByEmailPhoneToUse" + nextReminder] ? depa.phoneToUse : null;

                if (!_customer["reminderByPositionDepa" + nextReminder]) {
                  _context8.next = 553;
                  break;
                }

                _iteratorNormalCompletion15 = true;
                _didIteratorError15 = false;
                _iteratorError15 = undefined;
                _context8.prev = 407;
                _iterator15 = _customer["reminderByPositionDepa" + nextReminder][Symbol.iterator]();

              case 409:
                if (_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done) {
                  _context8.next = 539;
                  break;
                }

                _position2 = _step15.value;

                if (!(_position2 === "Conducteur")) {
                  _context8.next = 416;
                  break;
                }

                if (depa.driver.cellularPhone && (!_customer["reminderByEmailPhoneToUse" + nextReminder] || !depa.phoneToUse)) {
                  depa.phoneToUse = depa.driver.cellularPhone;
                }
                if (depa.driver.email) {
                  _emails.push(depa.driver.email);
                }
                _context8.next = 536;
                break;

              case 416:
                if (!(_position2 === "Manageur")) {
                  _context8.next = 423;
                  break;
                }

                _context8.next = 419;
                return UsersService.getById(depa.driver.defaultManagerId);

              case 419:
                _manager16 = _context8.sent;

                if (_manager16 && _manager16.email) {
                  _emails.push(_manager16.email);
                }
                _context8.next = 536;
                break;

              case 423:
                if (!(_position2 === "RH")) {
                  _context8.next = 430;
                  break;
                }

                _context8.next = 426;
                return UsersService.getById(depa.driver.rhManagerId);

              case 426:
                _manager17 = _context8.sent;

                if (_manager17 && _manager17.email) {
                  _emails.push(_manager17.email);
                }
                _context8.next = 536;
                break;

              case 430:
                if (!(_position2 === "QSE")) {
                  _context8.next = 437;
                  break;
                }

                _context8.next = 433;
                return UsersService.getById(depa.driver.qseManagerId);

              case 433:
                _manager18 = _context8.sent;

                if (_manager18 && _manager18.email) {
                  _emails.push(_manager18.email);
                }
                _context8.next = 536;
                break;

              case 437:
                if (!(_position2 === "Gestionnaire Parc")) {
                  _context8.next = 444;
                  break;
                }

                _context8.next = 440;
                return UsersService.getById(depa.driver.fleetManagerId);

              case 440:
                _manager19 = _context8.sent;

                if (_manager19 && _manager19.email) {
                  _emails.push(_manager19.email);
                }
                _context8.next = 536;
                break;

              case 444:
                if (!(_position2 === "Autre responsable 1")) {
                  _context8.next = 451;
                  break;
                }

                _context8.next = 447;
                return UsersService.getById(depa.driver.other1ManagerId);

              case 447:
                _manager20 = _context8.sent;

                if (_manager20 && _manager20.email) {
                  _emails.push(_manager20.email);
                }
                _context8.next = 536;
                break;

              case 451:
                if (!(_position2 === "Autre responsable 2")) {
                  _context8.next = 458;
                  break;
                }

                _context8.next = 454;
                return UsersService.getById(depa.driver.other2ManagerId);

              case 454:
                _manager21 = _context8.sent;

                if (_manager21 && _manager21.email) {
                  _emails.push(_manager21.email);
                }
                _context8.next = 536;
                break;

              case 458:
                if (!(_position2 === "LEAD" && _customer._leadIds && _customer._leadIds.length)) {
                  _context8.next = 489;
                  break;
                }

                _iteratorNormalCompletion16 = true;
                _didIteratorError16 = false;
                _iteratorError16 = undefined;
                _context8.prev = 462;
                _iterator16 = _customer._leadIds[Symbol.iterator]();

              case 464:
                if (_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done) {
                  _context8.next = 473;
                  break;
                }

                _leadId2 = _step16.value;
                _context8.next = 468;
                return UsersService.getById(_leadId2);

              case 468:
                _lead2 = _context8.sent;

                if (_lead2 && _lead2.email) {
                  _emails.push(_lead2.email);
                }

              case 470:
                _iteratorNormalCompletion16 = true;
                _context8.next = 464;
                break;

              case 473:
                _context8.next = 479;
                break;

              case 475:
                _context8.prev = 475;
                _context8.t8 = _context8["catch"](462);
                _didIteratorError16 = true;
                _iteratorError16 = _context8.t8;

              case 479:
                _context8.prev = 479;
                _context8.prev = 480;

                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                  _iterator16.return();
                }

              case 482:
                _context8.prev = 482;

                if (!_didIteratorError16) {
                  _context8.next = 485;
                  break;
                }

                throw _iteratorError16;

              case 485:
                return _context8.finish(482);

              case 486:
                return _context8.finish(479);

              case 487:
                _context8.next = 536;
                break;

              case 489:
                if (!(_position2 === "Responsable DRM" && _customer._drmRespIds && _customer._drmRespIds.length)) {
                  _context8.next = 520;
                  break;
                }

                _iteratorNormalCompletion17 = true;
                _didIteratorError17 = false;
                _iteratorError17 = undefined;
                _context8.prev = 493;
                _iterator17 = _customer._drmRespIds[Symbol.iterator]();

              case 495:
                if (_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done) {
                  _context8.next = 504;
                  break;
                }

                _drmRespId2 = _step17.value;
                _context8.next = 499;
                return UsersService.getById(_drmRespId2);

              case 499:
                _drmResp2 = _context8.sent;

                if (_drmResp2 && _drmResp2.email) {
                  _emails.push(_drmResp2.email);
                }

              case 501:
                _iteratorNormalCompletion17 = true;
                _context8.next = 495;
                break;

              case 504:
                _context8.next = 510;
                break;

              case 506:
                _context8.prev = 506;
                _context8.t9 = _context8["catch"](493);
                _didIteratorError17 = true;
                _iteratorError17 = _context8.t9;

              case 510:
                _context8.prev = 510;
                _context8.prev = 511;

                if (!_iteratorNormalCompletion17 && _iterator17.return) {
                  _iterator17.return();
                }

              case 513:
                _context8.prev = 513;

                if (!_didIteratorError17) {
                  _context8.next = 516;
                  break;
                }

                throw _iteratorError17;

              case 516:
                return _context8.finish(513);

              case 517:
                return _context8.finish(510);

              case 518:
                _context8.next = 536;
                break;

              case 520:
                if (!(_position2 === "Responsable du suivi")) {
                  _context8.next = 527;
                  break;
                }

                _context8.next = 523;
                return UsersService.getById(depa.managerId);

              case 523:
                _manager22 = _context8.sent;

                if (_manager22 && _manager22.email) {
                  _emails.push(_manager22.email);
                }
                _context8.next = 536;
                break;

              case 527:
                if (!(_position2 === "N+2")) {
                  _context8.next = 536;
                  break;
                }

                _context8.next = 530;
                return UsersService.getById(depa.driver.defaultManagerId);

              case 530:
                _manager23 = _context8.sent;

                if (!(_manager23 && _manager23.defaultManagerId)) {
                  _context8.next = 536;
                  break;
                }

                _context8.next = 534;
                return UsersService.getById(_manager23.defaultManagerId);

              case 534:
                _managerN2 = _context8.sent;

                if (_managerN2 && _managerN2.email) {
                  _emails.push(_managerN2.email);
                }

              case 536:
                _iteratorNormalCompletion15 = true;
                _context8.next = 409;
                break;

              case 539:
                _context8.next = 545;
                break;

              case 541:
                _context8.prev = 541;
                _context8.t10 = _context8["catch"](407);
                _didIteratorError15 = true;
                _iteratorError15 = _context8.t10;

              case 545:
                _context8.prev = 545;
                _context8.prev = 546;

                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                  _iterator15.return();
                }

              case 548:
                _context8.prev = 548;

                if (!_didIteratorError15) {
                  _context8.next = 551;
                  break;
                }

                throw _iteratorError15;

              case 551:
                return _context8.finish(548);

              case 552:
                return _context8.finish(545);

              case 553:
                if (!_customer["reminderByUserDepa" + nextReminder]) {
                  _context8.next = 582;
                  break;
                }

                _iteratorNormalCompletion18 = true;
                _didIteratorError18 = false;
                _iteratorError18 = undefined;
                _context8.prev = 557;
                _iterator18 = _customer["reminderByUserDepa" + nextReminder][Symbol.iterator]();

              case 559:
                if (_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done) {
                  _context8.next = 568;
                  break;
                }

                _userId2 = _step18.value;
                _context8.next = 563;
                return UsersService.getById(_userId2);

              case 563:
                _user2 = _context8.sent;

                if (_user2 && _user2.email) {
                  _emails.push(_user2.email);
                }

              case 565:
                _iteratorNormalCompletion18 = true;
                _context8.next = 559;
                break;

              case 568:
                _context8.next = 574;
                break;

              case 570:
                _context8.prev = 570;
                _context8.t11 = _context8["catch"](557);
                _didIteratorError18 = true;
                _iteratorError18 = _context8.t11;

              case 574:
                _context8.prev = 574;
                _context8.prev = 575;

                if (!_iteratorNormalCompletion18 && _iterator18.return) {
                  _iterator18.return();
                }

              case 577:
                _context8.prev = 577;

                if (!_didIteratorError18) {
                  _context8.next = 580;
                  break;
                }

                throw _iteratorError18;

              case 580:
                return _context8.finish(577);

              case 581:
                return _context8.finish(574);

              case 582:

                // remove duplicates
                _emails = _emails.filter(function (item, index) {
                  return _emails.indexOf(item) === index;
                });

                // replace only if there is at least one email
                if (_emails.length > 0) {
                  depa.emailToUse = _emails.join(",");
                }

              case 584:
                if (!(depa && (depa.emailToUse || depa.phoneToUse) && depa.status !== "Programmé" && depa.status !== "Effectué" && (!depa.missingCount || depa.missingCount < 3))) {
                  _context8.next = 651;
                  break;
                }

                container = document.createElement("div");
                buttonText = "Modifier le destinataire ou prendre le RDV";
                text = "Voulez-vous renvoyer le lien pour programmer le RDV de";

                if (depa.status === "Annulé") {
                  buttonText = "Modifier le destinataire";
                  text = "Voulez-vous envoyer le mail/sms d'annulation du DEPA de";
                  // const buttonReactivate = document.createElement('button');
                  // buttonReactivate.className = 'swal-button swal-button--danger';
                  // buttonReactivate.innerHTML = 'Réactiver le DEPA';
                  // buttonReactivate.onclick = async function onClick() {
                  //   swal.close();
                  //   await reactivateDepa(depa);
                  // }
                  // container.append(buttonReactivate);
                  // container.append(document.createElement("br"));
                  // container.append(document.createElement("br"));
                }

                button = document.createElement("button");

                button.className = "swal-button";
                button.innerHTML = buttonText;
                button.onclick = function () {
                  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            swal.close();
                            _context7.next = 3;
                            return schedule(depa);

                          case 3:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7, this);
                  }));

                  function onClick() {
                    return _ref8.apply(this, arguments);
                  }

                  return onClick;
                }();
                container.append(button);

                _context8.next = 596;
                return swal({
                  text: text + " " + depa.driverName + " ? \n" + (depa.emailToUse ? " \n[ email : " + depa.emailToUse + " ] " : "[ email : ??? ]") + " " + (depa.phoneToUse ? " \n[ sms : " + depa.phoneToUse + " ]" : "[ sms : ??? ]"),
                  content: {
                    element: container
                  },
                  icon: "warning",
                  dangerMode: true,
                  buttons: ["Non", "Oui"]
                });

              case 596:
                confirmSend = _context8.sent;
                allowSave = true;
                phoneMobileRegex = /^\+[1-9]\d{6,14}$/;


                if (depa.phoneToUse && !phoneMobileRegex.test(depa.phoneToUse)) {
                  Notiflix.Notify.failure("Le format du portable n'est pas valide");
                  allowSave = false;
                }

                emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (!depa.emailToUse) {
                  _context8.next = 621;
                  break;
                }

                _iteratorNormalCompletion19 = true;
                _didIteratorError19 = false;
                _iteratorError19 = undefined;
                _context8.prev = 605;

                for (_iterator19 = depa.emailToUse.split(",")[Symbol.iterator](); !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                  email = _step19.value;

                  if (email && !emailRegex.test(email)) {
                    Notiflix.Notify.failure("Le format de l'email n'est pas valide");
                    allowSave = false;
                  }
                }
                _context8.next = 613;
                break;

              case 609:
                _context8.prev = 609;
                _context8.t12 = _context8["catch"](605);
                _didIteratorError19 = true;
                _iteratorError19 = _context8.t12;

              case 613:
                _context8.prev = 613;
                _context8.prev = 614;

                if (!_iteratorNormalCompletion19 && _iterator19.return) {
                  _iterator19.return();
                }

              case 616:
                _context8.prev = 616;

                if (!_didIteratorError19) {
                  _context8.next = 619;
                  break;
                }

                throw _iteratorError19;

              case 619:
                return _context8.finish(616);

              case 620:
                return _context8.finish(613);

              case 621:
                if (!(confirmSend && allowSave)) {
                  _context8.next = 649;
                  break;
                }

                if (!(!depa.emailToUse && !depa.phoneToUse)) {
                  _context8.next = 625;
                  break;
                }

                Notiflix.Notify.failure("Vous devez indiquer un numéro de téléphone ou un email.");
                return _context8.abrupt("return");

              case 625:
                values = { emailName: "toScheduled" };

                values.emailToUse = depa.emailToUse;
                values.phoneToUse = depa.phoneToUse;
                if (depa.status === "Annulé") {
                  values.emailName = "meetingCancel";
                } else {
                  if (depa.status.endsWith("A reprogrammer")) {
                    values.emailName = "driverNotAvailable";
                  }
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context8.prev = 630;
                _context8.next = 633;
                return DepasService.updateAttributesById(depa._id, values);

              case 633:
                response = _context8.sent;

                if (response._id) {
                  _context8.next = 638;
                  break;
                }

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context8.abrupt("return");

              case 638:
                Notiflix.Loading.remove();
                Notiflix.Notify.success("La demande a bien été prise en compte.");
                _context8.next = 647;
                break;

              case 642:
                _context8.prev = 642;
                _context8.t13 = _context8["catch"](630);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context8.abrupt("return");

              case 647:
                vm.refresh();
                return _context8.abrupt("return");

              case 649:
                _context8.next = 653;
                break;

              case 651:
                _context8.next = 653;
                return schedule(depa);

              case 653:
                _context8.next = 659;
                break;

              case 655:
                _context8.prev = 655;
                _context8.t14 = _context8["catch"](2);

                console.log("scheduleDepa", _context8.t14);
                Notiflix.Notify.failure("Une erreur est survenue");

              case 659:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this, [[2, 655], [32, 166, 170, 178], [87, 100, 104, 112], [105,, 107, 111], [118, 131, 135, 143], [136,, 138, 142], [171,, 173, 177], [182, 195, 199, 207], [200,, 202, 206], [224, 358, 362, 370], [279, 292, 296, 304], [297,, 299, 303], [310, 323, 327, 335], [328,, 330, 334], [363,, 365, 369], [374, 387, 391, 399], [392,, 394, 398], [407, 541, 545, 553], [462, 475, 479, 487], [480,, 482, 486], [493, 506, 510, 518], [511,, 513, 517], [546,, 548, 552], [557, 570, 574, 582], [575,, 577, 581], [605, 609, 613, 621], [614,, 616, 620], [630, 642]]);
      }));

      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }();

    vm.displayInfo = function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(depa) {
        var source, accidentValues, glassValues, horsAccidentValues, explicitValues, commentDetails, emails, depaLines, accidentOriginList, accidentOrigin, forms;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                source = READ_SUMMARY_URL + "/";
                accidentValues = ["circulation", "maneuver"];
                glassValues = ["glass"];
                horsAccidentValues = ["parking", "theft", "disaster", "fire", "handling", "repair", "building"];
                explicitValues = [].concat(accidentValues, glassValues, horsAccidentValues);
                commentDetails = "DEPA du sinistre n\xB0" + depa.damageName + " (" + (depa.typeOfAccidentName ? depa.typeOfAccidentName : "???") + ") du " + moment(depa.dateDamage).format("DD/MM/YYYY") + " du conducteur " + depa.driverName + " " + (explicitValues.includes(depa.typeOfAccident) ? "avec le véhicule " + depa.vehicleName : "") + " :<br/>" + depa.circumstance;

                if (!(vm.isAdmin == true || vm.isLvr == true)) {
                  _context9.next = 12;
                  break;
                }

                _context9.next = 9;
                return EmailHistoryService.find({
                  filter: {
                    where: {
                      $or: [{ damageId: { $eq: depa.damageId.replace("$", "") } }, { _damageId: { $eq: depa.damageId.replace("$", "") } }]
                    },
                    fields: ["_id", "customerId", "from", "to", "cc", "bcc", "creationDate", "subject", "readDate", "status", "reports", "report", "shortId", "phone", "smsStatus", "smsText", "triggeredBy", "error", "html"],
                    order: { creationDate: -1 }
                  }
                });

              case 9:
                _context9.t0 = _context9.sent;
                _context9.next = 13;
                break;

              case 12:
                _context9.t0 = [];

              case 13:
                emails = _context9.t0;
                depaLines = [{
                  label: "Collaborateur",
                  value: depa.driverName + (depa.driverInternalNumber ? " (" + depa.driverInternalNumber + ")" : "") + (depa.driverEmail ? "<br/>" + depa.driverEmail : "") + (depa.driverCellularPhone ? "<br/>" + depa.driverCellularPhone : "")
                }, {
                  label: "Contact pour la prise de RDV",
                  value: (depa.scheduleUserName ? depa.scheduleUserName : "???") + (depa.emailToUse ? "<br/>" + depa.emailToUse : "") + (depa.phoneToUse ? "<br/>" + depa.phoneToUse : ""),
                  hidden: depa.status === "Annulé" || depa.status === "Effectué"
                }, {
                  label: "Date du sinistre",
                  value: moment(depa.dateDamage).format("DD/MM/YYYY"),
                  titleBefore: "Sinistre"
                }, {
                  label: "Responsable du suivi du sinistre",
                  value: depa.damageManagerName + (depa.damageManagerEmail ? "<br/>" + depa.damageManagerEmail : "")
                }, {
                  label: "Statut",
                  value: depa.status + (depa.status === "Annulé" ? " - Raison : " + depa.reasonCancelName : ""),
                  titleBefore: "RDV"
                }, {
                  label: "Date du RDV",
                  value: depa.slot ? "Le " + moment(depa.slot.start).format("DD/MM/YYYY à HH:mm") + (depa.phone ? " au " + depa.phone : "") + " avec " + depa.operatorName : "",
                  hidden: depa.status === "Annulé"
                }, {
                  label: "RDV manqué(s) pour ce DEPA",
                  value: depa.missingCount ? depa.missingCount : 0,
                  hidden: !depa.missingCount,
                  isWarning: depa.missingCount > 0
                }, {
                  label: "Type de sinistre",
                  value: depa.typeOfAccidentName,
                  titleBefore: "Synthèse"
                }, {
                  label: "Circonstances",
                  value: depa.circumstance
                }, {
                  label: "Mots clés",
                  value: depa.answers && depa.answers.keywords ? depa.answers.keywords.map(function (keyword) {
                    return "#" + keyword;
                  }).join(", ") : "",
                  hidden: depa.status !== "Effectué"
                }, {
                  label: "Evitabilité",
                  value: depa.answers ? depa.answers.commentSuggestions ? depa.answers.commentSuggestions : depa.answers.commentGlass ? depa.answers.commentGlass : "" : "",
                  hidden: depa.status !== "Effectué"
                }, {
                  label: "Évitable pour le conducteur",
                  value: depa.answers ? depa.answers.isEvitable === true ? "Oui" : depa.answers.isEvitable === false ? "Non" : "" : "",
                  hidden: depa.status !== "Effectué"
                }, {
                  label: "Évitable pour LVR",
                  value: depa.answers ? depa.answers.isEvitableLvr === true ? "Oui" : depa.answers.isEvitableLvr === false ? "Non" : "" : "",
                  hidden: depa.status !== "Effectué" || depa.answers.isEvitable === true
                }, {
                  label: "Conseils LVR",
                  value: depa.answers ? depa.answers.commentAdvices ? depa.answers.commentAdvices : depa.answers.commentNotEvitable ? depa.answers.commentNotEvitable : "" : "",
                  hidden: depa.status !== "Effectué" || depa.answers.isEvitable === true
                }, {
                  label: "Évaluation de l'entretien",
                  value: depa.answers ? depa.answers.interviewEvaluation ? depa.answers.interviewEvaluation[0] + "/5" : "" : "",
                  hidden: depa.status !== "Effectué"
                }, {
                  label: "Corporel ?",
                  value: depa.answers ? depa.answers.withInjuries === true ? "Oui" : depa.answers.withInjuries === false ? "Non" : "" : "",
                  hidden: depa.status !== "Effectué"
                }, {
                  label: "Avec impact psychologique ?",
                  value: depa.answers ? depa.answers.withPsychologicalImpact === true ? "Oui" : depa.answers.withPsychologicalImpact === false ? "Non" : "" : "",
                  hidden: depa.status !== "Effectué"
                }, {
                  label: "Date de l'acte managérial",
                  value: depa.managerAct ? depa.managerAct.actDate ? moment(depa.managerAct.actDate).format("DD/MM/YYYY") : "" : "",
                  hidden: !depa.managerAct
                }, {
                  label: "L'acte managérial a eu lieu",
                  value: depa.managerActMethodName,
                  hidden: !depa.managerAct
                }, {
                  label: "Commentaires du manageur",
                  value: depa.managerAct ? depa.managerAct.comment : "",
                  hidden: !depa.managerAct
                }, {
                  label: "Raison d'annulation de l'acte managérial",
                  value: depa.managerActCancelReasonName,
                  hidden: !depa.managerActCancelled
                }, {
                  label: "Détails de l'annulation de l'acte managérial",
                  value: depa.managerActCancelReasonDetails,
                  hidden: !depa.managerActCancelled
                }];


                if (vm.isLvr && depa.answers && depa.answers.commentOnDriver && depa.answers.commentOnDriver.replace(/\s/g, "")) {
                  depaLines.push({
                    label: "Commentaire interne LVR",
                    value: depa.answers.commentOnDriver,
                    titleBefore: "Interne LVR",
                    hiddenIfPrint: true
                  });
                }

                if (!(vm.isLvr && depa.answers && depa.answers.accidentOrigin && depa.answers.accidentOrigin.length)) {
                  _context9.next = 22;
                  break;
                }

                _context9.next = 19;
                return CustomListsService.getSelectArray("accidentOrigin");

              case 19:
                accidentOriginList = _context9.sent;
                accidentOrigin = accidentOriginList.find(function (origin) {
                  return origin.value === depa.answers.accidentOrigin[0];
                });

                depaLines.push({
                  titleBefore: depa.answers && depa.answers.commentOnDriver && depa.answers.commentOnDriver.replace(/\s/g, "") ? "" : "Interne LVR",
                  label: "Défaillance humaine à l'origine des accidents",
                  value: accidentOrigin ? accidentOrigin.name : depa.answers.accidentOrigin[0],
                  hiddenIfPrint: true
                });

              case 22:
                forms = [{
                  name: "",
                  filters: ["Fiche"],
                  lines: depaLines
                }, {
                  name: "Documents",
                  filters: ["Fiche", "Documents"],
                  lines: [{
                    label: "Documents associés au DEPA",
                    value: [].concat(_toConsumableArray(depa.docs && depa.docs.length ? [depa.docs[depa.docs.length - 1]] // Seul le dernier document (le + à jour) est affiché
                    : []), _toConsumableArray(depa.managerAct && depa.managerAct.docs ? depa.managerAct.docs.map(function (doc) {
                      doc.name = "Acte managérial - " + doc.name;
                      return doc;
                    }) : []))
                  }, {
                    label: "Documents à transmettre à l'assureur",
                    value: depa.damageDocs
                  }, {
                    label: "Documents internes",
                    value: depa.damageDocsBilling
                  }]
                }];
                _context9.next = 25;
                return DepasService.getHistory(depa._id);

              case 25:
                depa.history = _context9.sent;


                ModalService.openComponent("custom-iframe", {
                  source: source,
                  title: "Fiche récapitulative",
                  size: "lg",
                  keyboard: false,
                  heightCalculationMethod: "bodyOffset",
                  closeEvent: "mutationObserver",
                  message: {
                    emails: emails,
                    object: depa,
                    customerName: depa.customerName,
                    titleName: "DEPA du sinistre n°" + depa.damageName,
                    headerName: "Fiche récapitulative DEPA",
                    footerName: "DEPA du sinistre n°" + depa.damageName,
                    fileName: "Fiche r\xE9cap - " + depa.driverName + " - DEPA du sinistre du " + moment(depa.dateDamage).format("DD-MM-YYYY"),
                    commentDetails: commentDetails,
                    filters: ["Fiche", "Documents"],
                    forms: forms,
                    videos: [].concat(_toConsumableArray(depa.damageDocs || []), _toConsumableArray(depa.damageDocsBilling || [])).filter(function (doc) {
                      return doc.url.match(/\.(mp4|webm|ogg)(\?.*)?$/i);
                    })
                  }
                }).then(function () {
                  console.log("close modal");
                }).catch(function (err) {
                  console.error("err", err);
                });

              case 27:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      return function (_x7) {
        return _ref9.apply(this, arguments);
      };
    }();

    vm.openPdf = function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(row) {
        var token, currentUserGroupIds, view, interviewDocument;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!($rootScope.$user.role === "super-admin")) {
                  _context10.next = 8;
                  break;
                }

                _context10.next = 3;
                return ApiService.getToken();

              case 3:
                token = _context10.sent;
                currentUserGroupIds = $rootScope.$user.groupsId;
                view = currentUserGroupIds.some(function (groupId) {
                  return groupId === "$633be6ad8a10010012815d87";
                }) ? "preventeur" : currentUserGroupIds.some(function (groupId) {
                  return groupId === "$65f2d6bf5075b5001298901a";
                }) ? "detaillee" : "standard";

                window.open(DEPA_FORM_URL + "/?id=" + row._id + "&shortId=" + row.shortId + "&token=" + token + "&trainingMode=false&view=" + view, "_blank");
                return _context10.abrupt("return");

              case 8:
                interviewDocument = DepasService.getLatestInterviewDocument(row);

                if (interviewDocument) {
                  try {
                    window.open(interviewDocument.url, "_blank");
                  } catch (error) {
                    Notiflix.Notify.failure("Une erreur est survenue lors du téléchargement du PDF.");
                  }
                } else {
                  Notiflix.Notify.failure("Absence de fiche entretien. Contactez le support.");
                }

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      return function (_x8) {
        return _ref10.apply(this, arguments);
      };
    }();

    vm.notAvailable = function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(row) {
        var reasonNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        var value, details, select, emptyOption, _iteratorNormalCompletion20, _didIteratorError20, _iteratorError20, _iterator20, _step20, reason, option, textarea, label1, label2, div, notAvailable, data, missingDate, _missingDate, response, depa;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // Warning: fn(data, ctx) in agridService.button !
                value = void 0;
                details = void 0;

                if (reasonNumber === 1 && row.meeting1MissingReason) {
                  value = row.meeting1MissingReason;
                  details = row.meeting1MissingReasonDetails ? row.meeting1MissingReasonDetails : null;
                } else if (reasonNumber === 2 && row.meeting2MissingReason) {
                  value = row.meeting2MissingReason;
                  details = row.meeting2MissingReasonDetails ? row.meeting2MissingReasonDetails : null;
                } else if (reasonNumber === 3 && row.meeting3MissingReason) {
                  value = row.meeting3MissingReason;
                  details = row.meeting3MissingReasonDetails ? row.meeting3MissingReasonDetails : null;
                } else if (reasonNumber === 4 && row.meetingLastMissingReason) {
                  value = row.meetingLastMissingReason;
                  details = row.meetingLastMissingReasonDetails ? row.meetingLastMissingReasonDetails : null;
                }
                select = document.createElement("select");

                select.className = "form-control";

                emptyOption = document.createElement("option");

                emptyOption.innerHTML = "";
                emptyOption.value = "";
                select.appendChild(emptyOption);
                _iteratorNormalCompletion20 = true;
                _didIteratorError20 = false;
                _iteratorError20 = undefined;
                _context11.prev = 12;
                _iterator20 = vm.reasonsDriverNotAvailable[Symbol.iterator]();

              case 14:
                if (_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done) {
                  _context11.next = 26;
                  break;
                }

                reason = _step20.value;

                if (!reason.value.endsWith("Auto")) {
                  _context11.next = 18;
                  break;
                }

                return _context11.abrupt("continue", 23);

              case 18:
                option = document.createElement("option");

                option.innerHTML = reason.name;
                option.value = reason.value;
                if (typeof reasonNumber === "number" && reasonNumber === 1) {
                  option.selected = reason.value === row.meeting1MissingReason;
                } else if (typeof reasonNumber === "number" && reasonNumber === 2) {
                  option.selected = reason.value === row.meeting2MissingReason;
                } else if (typeof reasonNumber === "number" && reasonNumber === 3) {
                  option.selected = reason.value === row.meeting3MissingReason;
                } else if (typeof reasonNumber === "number" && reasonNumber === 4) {
                  option.selected = reason.value === row.meetingLastMissingReason;
                }
                select.appendChild(option);

              case 23:
                _iteratorNormalCompletion20 = true;
                _context11.next = 14;
                break;

              case 26:
                _context11.next = 32;
                break;

              case 28:
                _context11.prev = 28;
                _context11.t0 = _context11["catch"](12);
                _didIteratorError20 = true;
                _iteratorError20 = _context11.t0;

              case 32:
                _context11.prev = 32;
                _context11.prev = 33;

                if (!_iteratorNormalCompletion20 && _iterator20.return) {
                  _iterator20.return();
                }

              case 35:
                _context11.prev = 35;

                if (!_didIteratorError20) {
                  _context11.next = 38;
                  break;
                }

                throw _iteratorError20;

              case 38:
                return _context11.finish(35);

              case 39:
                return _context11.finish(32);

              case 40:

                select.onchange = function selectChanged(e) {
                  value = e.target.value;
                };

                textarea = document.createElement("textarea");

                textarea.innerHTML = details ? details : "";
                textarea.className = "form-control";
                textarea.onchange = function selectChanged(e) {
                  details = e.target.value;
                };

                label1 = document.createElement("label");

                label1.innerHTML = "Raison :";

                label2 = document.createElement("label");

                label2.innerHTML = "Détails :";

                div = document.createElement("div");

                div.appendChild(label1);
                div.appendChild(select);
                div.appendChild(label2);
                div.appendChild(textarea);

                _context11.next = 56;
                return swal({
                  title: typeof reasonNumber === "number" && reasonNumber > 0 ? "Voulez-vous \xE9diter la raison ?" : "Voulez-vous reporter le DEPA de " + row.driverName + " ?",
                  content: {
                    element: div
                  },
                  icon: "warning",
                  dangerMode: true,
                  buttons: ["Annuler", "Valider"]
                });

              case 56:
                notAvailable = _context11.sent;

                if (!(notAvailable && value)) {
                  _context11.next = 86;
                  break;
                }

                console.log("need to reschedule this depa", row);

                data = void 0;
                // if the reason (only) is edited

                if (typeof reasonNumber === "number" && reasonNumber > 0) {
                  data = {};
                  if (reasonNumber === 1) {
                    data.meeting1MissingReason = value;
                    data.meeting1MissingReasonDetails = details;
                  } else if (reasonNumber === 2) {
                    data.meeting2MissingReason = value;
                    data.meeting2MissingReasonDetails = details;
                  } else if (reasonNumber === 3) {
                    data.meeting3MissingReason = value;
                    data.meeting3MissingReasonDetails = details;
                  } else if (reasonNumber === 4) {
                    data.meetingLastMissingReason = value;
                    data.meetingLastMissingReasonDetails = details;
                  }
                  // if the DEPA is rescheduled
                } else {
                  if (row.missingCount && row.missingCount >= 3) {
                    // if the DEPA is rescheduled after 3 missing dates -> cancel the DEPA
                    missingDate = row.slot.start;

                    data = {
                      meetingCancel: true,
                      reasonCancel: "tooManyMissingAuto",
                      missingCount: row.missingCount + 1,
                      answers: null, // reset answers
                      meetingLastMissingDate: missingDate,
                      meetingLastMissingReason: value,
                      meetingLastMissingReasonDetails: details,
                      meetingLastMissingUserId: "$" + $rootScope.$user._id
                    };
                  } else {
                    _missingDate = row.slot.start;

                    data = {
                      driverNotAvailable: true,
                      missingCount: row.missingCount ? row.missingCount + 1 : 1,
                      answers: null // reset answers
                    };
                    if (row.meeting1MissingDate) {
                      if (row.meeting2MissingDate) {
                        data.meeting3MissingDate = _missingDate;
                        data.meeting3MissingReason = value;
                        data.meeting3MissingReasonDetails = details;
                        data.meeting3MissingUserId = "$" + $rootScope.$user._id;
                      } else {
                        data.meeting2MissingDate = _missingDate;
                        data.meeting2MissingReason = value;
                        data.meeting2MissingReasonDetails = details;
                        data.meeting2MissingUserId = "$" + $rootScope.$user._id;
                      }
                    } else {
                      data.meeting1MissingDate = _missingDate;
                      data.meeting1MissingReason = value;
                      data.meeting1MissingReasonDetails = details;
                      data.meeting1MissingUserId = "$" + $rootScope.$user._id;
                    }
                  }
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context11.prev = 62;
                _context11.next = 65;
                return DepasService.updateAttributesById(row._id, data);

              case 65:
                response = _context11.sent;

                if (response._id) {
                  _context11.next = 70;
                  break;
                }

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context11.abrupt("return");

              case 70:
                Notiflix.Loading.remove();
                _context11.next = 78;
                break;

              case 73:
                _context11.prev = 73;
                _context11.t1 = _context11["catch"](62);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context11.abrupt("return");

              case 78:
                _context11.next = 80;
                return vm.refresh();

              case 80:
                if (!(typeof reasonNumber !== "number" && (!row.missingCount || row.missingCount + 1 < 3))) {
                  _context11.next = 84;
                  break;
                }

                depa = vm.rawData.find(function (item) {
                  return item._id === row._id;
                });
                _context11.next = 84;
                return vm.scheduleDepa(depa);

              case 84:
                _context11.next = 87;
                break;

              case 86:
                if (notAvailable) {
                  Notify.warning("Veuillez choisir une raison avant de valider !");
                }

              case 87:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this, [[12, 28, 32, 40], [33,, 35, 39], [62, 73]]);
      }));

      return function (_x9) {
        return _ref11.apply(this, arguments);
      };
    }();

    vm.editNotAvailable1 = function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(row) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return vm.notAvailable(row, 1);

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this);
      }));

      return function (_x11) {
        return _ref12.apply(this, arguments);
      };
    }();

    vm.editNotAvailable2 = function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(row) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return vm.notAvailable(row, 2);

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this);
      }));

      return function (_x12) {
        return _ref13.apply(this, arguments);
      };
    }();

    vm.editNotAvailable3 = function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(row) {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return vm.notAvailable(row, 3);

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this);
      }));

      return function (_x13) {
        return _ref14.apply(this, arguments);
      };
    }();

    vm.editNotAvailableLast = function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(row) {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return vm.notAvailable(row, 4);

              case 2:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this);
      }));

      return function (_x14) {
        return _ref15.apply(this, arguments);
      };
    }();

    vm.editCancel = function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(row) {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return vm.cancel(row, true);

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this);
      }));

      return function (_x15) {
        return _ref16.apply(this, arguments);
      };
    }();

    vm.cancel = function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(row) {
        var onlyValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var data, willInform, response, value, details, select, emptyOption, _iteratorNormalCompletion21, _didIteratorError21, _iteratorError21, _iterator21, _step21, reason, option, textarea, label1, label2, div, cancel, _data, typeOfAccidentFromReasonCancel, visibleTypes, driver, _response, updatedDepa;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(row.status === "Annulé" && typeof onlyValue !== "boolean" && vm.isLvr)) {
                  _context17.next = 5;
                  break;
                }

                _context17.next = 3;
                return vm.reactivateDepa(row);

              case 3:
                _context17.next = 132;
                break;

              case 5:
                if (!(vm.isAdmin && !vm.isLvr)) {
                  _context17.next = 32;
                  break;
                }

                data = { meetingCancel: true, reasonCancel: "byCustomer" };
                _context17.next = 9;
                return swal({
                  //title: "",
                  text: "Voulez-vous annuler ce DEPA ?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                    cancel: "Non",
                    confirm: "Oui"
                  }
                });

              case 9:
                willInform = _context17.sent;

                if (!(willInform == true)) {
                  _context17.next = 30;
                  break;
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                _context17.prev = 12;
                _context17.next = 15;
                return DepasService.updateAttributesById(row._id, data);

              case 15:
                response = _context17.sent;

                if (response._id) {
                  _context17.next = 20;
                  break;
                }

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context17.abrupt("return");

              case 20:
                Notiflix.Loading.remove();
                _context17.next = 28;
                break;

              case 23:
                _context17.prev = 23;
                _context17.t0 = _context17["catch"](12);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context17.abrupt("return");

              case 28:
                _context17.next = 30;
                return vm.refresh();

              case 30:
                _context17.next = 132;
                break;

              case 32:
                if (!vm.isLvr) {
                  _context17.next = 132;
                  break;
                }

                value = row.reasonCancel ? row.reasonCancel : null;
                details = row.reasonCancelDetails ? row.reasonCancelDetails : null;
                select = document.createElement("select");

                select.className = "form-control";

                emptyOption = document.createElement("option");

                emptyOption.innerHTML = "";
                emptyOption.value = "";
                select.appendChild(emptyOption);
                _iteratorNormalCompletion21 = true;
                _didIteratorError21 = false;
                _iteratorError21 = undefined;
                _context17.prev = 44;
                _iterator21 = vm.reasonsDepaCancelled[Symbol.iterator]();

              case 46:
                if (_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done) {
                  _context17.next = 58;
                  break;
                }

                reason = _step21.value;

                if (!reason.value.endsWith("Auto")) {
                  _context17.next = 50;
                  break;
                }

                return _context17.abrupt("continue", 55);

              case 50:
                option = document.createElement("option");

                option.innerHTML = reason.name;
                option.value = reason.value;
                if (typeof onlyValue === "boolean" && onlyValue === true) {
                  option.selected = reason.value === row.reasonCancel;
                }
                select.appendChild(option);

              case 55:
                _iteratorNormalCompletion21 = true;
                _context17.next = 46;
                break;

              case 58:
                _context17.next = 64;
                break;

              case 60:
                _context17.prev = 60;
                _context17.t1 = _context17["catch"](44);
                _didIteratorError21 = true;
                _iteratorError21 = _context17.t1;

              case 64:
                _context17.prev = 64;
                _context17.prev = 65;

                if (!_iteratorNormalCompletion21 && _iterator21.return) {
                  _iterator21.return();
                }

              case 67:
                _context17.prev = 67;

                if (!_didIteratorError21) {
                  _context17.next = 70;
                  break;
                }

                throw _iteratorError21;

              case 70:
                return _context17.finish(67);

              case 71:
                return _context17.finish(64);

              case 72:

                select.onchange = function selectChanged(e) {
                  value = e.target.value;
                };

                textarea = document.createElement("textarea");

                textarea.innerHTML = details ? details : "";
                textarea.className = "form-control";
                textarea.onchange = function selectChanged(e) {
                  details = e.target.value;
                };

                label1 = document.createElement("label");

                label1.innerHTML = "Raison :";

                label2 = document.createElement("label");

                label2.innerHTML = "Détails :";

                div = document.createElement("div");

                div.appendChild(label1);
                div.appendChild(select);
                div.appendChild(label2);
                div.appendChild(textarea);

                _context17.next = 88;
                return swal({
                  title: typeof onlyValue === "boolean" && onlyValue === true ? "Voulez-vous \xE9diter la raison ?" : "Voulez-vous annuler le DEPA de " + row.driverName + " ?",
                  content: {
                    element: div
                  },
                  icon: "warning",
                  dangerMode: true,
                  buttons: ["Annuler", "Valider"]
                });

              case 88:
                cancel = _context17.sent;
                _data = void 0;

                if (typeof onlyValue === "boolean" && onlyValue === true) {
                  _data = { reasonCancel: value, reasonCancelDetails: details };
                } else {
                  // reset answers
                  _data = {
                    meetingCancel: true,
                    reasonCancel: value,
                    reasonCancelDetails: details,
                    answers: null
                  };
                }
                typeOfAccidentFromReasonCancel = vm.typeOfAccidentList.find(function (item) {
                  return item.value === value;
                });

                if (!(cancel && value)) {
                  _context17.next = 131;
                  break;
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                visibleTypes = vm.customer.visibleDamageTypes;

                if (!(typeOfAccidentFromReasonCancel && typeOfAccidentFromReasonCancel.value === value && (!visibleTypes || visibleTypes.indexOf(value) !== -1))) {
                  _context17.next = 100;
                  break;
                }

                _context17.next = 98;
                return DamagesService.updateAttributesById(row.damageId.replace("$", ""), {
                  typeOfAccident: value
                });

              case 98:
                _context17.next = 107;
                break;

              case 100:
                if (!(value === "driverGone")) {
                  _context17.next = 107;
                  break;
                }

                _context17.next = 103;
                return UsersService.getById(row.driverId.replace("$", ""));

              case 103:
                driver = _context17.sent;

                if (driver.endDate) {
                  _context17.next = 107;
                  break;
                }

                _context17.next = 107;
                return UsersService.updateAttributesById(row.driverId.replace("$", ""), {
                  endDate: new Date(),
                  note: driver.note ? driver.note + "\nConducteur sorti suite à l'annulation d'un DEPA pour ''Ne fait plus partie des effectifs''" : "Conducteur sorti suite à l'annulation d'un DEPA pour ''Ne fait plus partie des effectifs''"
                });

              case 107:
                _context17.prev = 107;
                _context17.next = 110;
                return DepasService.updateAttributesById(row._id, _data);

              case 110:
                _response = _context17.sent;

                if (_response._id) {
                  _context17.next = 115;
                  break;
                }

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context17.abrupt("return");

              case 115:
                Notiflix.Loading.remove();
                _context17.next = 123;
                break;

              case 118:
                _context17.prev = 118;
                _context17.t2 = _context17["catch"](107);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue lors de la sauvegarde.");
                return _context17.abrupt("return");

              case 123:
                _context17.next = 125;
                return vm.refresh();

              case 125:
                if (!(typeof onlyValue !== "boolean")) {
                  _context17.next = 129;
                  break;
                }

                updatedDepa = vm.rawData.find(function (item) {
                  return item._id === row._id;
                });
                _context17.next = 129;
                return vm.scheduleDepa(updatedDepa);

              case 129:
                _context17.next = 132;
                break;

              case 131:
                if (cancel) {
                  Notify.warning("Veuillez choisir une raison d'annulation avant de valider !");
                }

              case 132:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this, [[12, 23], [44, 60, 64, 72], [65,, 67, 71], [107, 118]]);
      }));

      return function (_x16) {
        return _ref17.apply(this, arguments);
      };
    }();

    vm.resendManagerAct = function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(row) {
        var willResend, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return swal({
                  //title: "",
                  text: "Voulez-vous renvoyer le mail avec le lien pour valider l'acte manag\xE9rial \xE0 " + row.managerName + " (" + row.managerEmail + ") ?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                    cancel: "Non",
                    confirm: "Oui"
                  }
                });

              case 2:
                willResend = _context18.sent;

                if (!(willResend == true)) {
                  _context18.next = 25;
                  break;
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context18.prev = 5;
                _context18.next = 8;
                return DepasService.customGet("sendManagerAct/" + row._id);

              case 8:
                response = _context18.sent;

                Notiflix.Loading.remove();

                if (!(response.success === true)) {
                  _context18.next = 16;
                  break;
                }

                Notiflix.Notify.success("L'email a été envoyé avec succès.");
                _context18.next = 14;
                return vm.refresh();

              case 14:
                _context18.next = 18;
                break;

              case 16:
                Notiflix.Notify.failure("Erreur lors de l'envoi de l'email.");
                return _context18.abrupt("return");

              case 18:
                _context18.next = 25;
                break;

              case 20:
                _context18.prev = 20;
                _context18.t0 = _context18["catch"](5);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Erreur lors de l'envoi de l'email.");
                return _context18.abrupt("return");

              case 25:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this, [[5, 20]]);
      }));

      return function (_x18) {
        return _ref18.apply(this, arguments);
      };
    }();

    vm.openManagerAct = function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(row) {
        var token, response, source;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                token = void 0;
                _context19.prev = 2;
                _context19.next = 5;
                return UsersService.get("auth/mobile-token");

              case 5:
                response = _context19.sent;

                token = response ? response.token : null;
                _context19.next = 14;
                break;

              case 9:
                _context19.prev = 9;
                _context19.t0 = _context19["catch"](2);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Erreur lors de la génération du lien de l'acte managérial.");
                return _context19.abrupt("return");

              case 14:

                Notiflix.Loading.remove();

                if (token) {
                  _context19.next = 18;
                  break;
                }

                Notiflix.Notify.failure("Erreur lors de la génération du lien de l'acte managérial.");
                return _context19.abrupt("return");

              case 18:
                source = APP_URL + "/?managerActId=" + encodeURIComponent(row.shortId) + "&token=" + encodeURIComponent(token);


                ModalService.openComponent("custom-iframe", {
                  source: source,
                  title: "",
                  size: "lg",
                  heightCalculationMethod: "bodyOffset",
                  minHeight: 850,
                  closeEvent: "init",
                  color: "#004369"
                }).then(function () {
                  console.log("close modal");
                  vm.refresh();
                }).catch(function (err) {
                  console.error("err", err);
                  vm.refresh();
                });

              case 20:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this, [[2, 9]]);
      }));

      return function (_x19) {
        return _ref19.apply(this, arguments);
      };
    }();

    vm.editManagerActCancelReason = function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(row) {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return vm.cancelManagerAct(row, true);

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this);
      }));

      return function (_x20) {
        return _ref20.apply(this, arguments);
      };
    }();

    vm.cancelManagerAct = function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(row) {
        var onlyValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var value, details, select, emptyOption, _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, reason, option, textarea, label1, label2, div, cancel, data, response;

        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                console.log("cancelManagerAct", row, onlyValue);

                if (!(row.managerActCancelled === true && (typeof onlyValue !== "boolean" || onlyValue !== true))) {
                  _context21.next = 5;
                  break;
                }

                _context21.next = 4;
                return vm.reactivateManagerAct(row);

              case 4:
                return _context21.abrupt("return");

              case 5:
                value = row.managerActCancelReason ? row.managerActCancelReason : null;
                details = row.managerActCancelReasonDetails ? row.managerActCancelReasonDetails : null;
                select = document.createElement("select");

                select.className = "form-control";

                emptyOption = document.createElement("option");

                emptyOption.innerHTML = "";
                emptyOption.value = "";
                select.appendChild(emptyOption);
                _iteratorNormalCompletion22 = true;
                _didIteratorError22 = false;
                _iteratorError22 = undefined;
                _context21.prev = 16;
                _iterator22 = vm.reasonsManagerActCancelled[Symbol.iterator]();

              case 18:
                if (_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done) {
                  _context21.next = 30;
                  break;
                }

                reason = _step22.value;

                if (!reason.value.endsWith("Auto")) {
                  _context21.next = 22;
                  break;
                }

                return _context21.abrupt("continue", 27);

              case 22:
                option = document.createElement("option");

                option.innerHTML = reason.name;
                option.value = reason.value;
                if (typeof onlyValue === "boolean" && onlyValue === true) {
                  option.selected = reason.value === row.managerActCancelReason;
                }
                select.appendChild(option);

              case 27:
                _iteratorNormalCompletion22 = true;
                _context21.next = 18;
                break;

              case 30:
                _context21.next = 36;
                break;

              case 32:
                _context21.prev = 32;
                _context21.t0 = _context21["catch"](16);
                _didIteratorError22 = true;
                _iteratorError22 = _context21.t0;

              case 36:
                _context21.prev = 36;
                _context21.prev = 37;

                if (!_iteratorNormalCompletion22 && _iterator22.return) {
                  _iterator22.return();
                }

              case 39:
                _context21.prev = 39;

                if (!_didIteratorError22) {
                  _context21.next = 42;
                  break;
                }

                throw _iteratorError22;

              case 42:
                return _context21.finish(39);

              case 43:
                return _context21.finish(36);

              case 44:

                select.onchange = function selectChanged(e) {
                  value = e.target.value;
                };

                textarea = document.createElement("textarea");

                textarea.innerHTML = details ? details : "";
                textarea.className = "form-control";
                textarea.onchange = function selectChanged(e) {
                  details = e.target.value;
                };

                label1 = document.createElement("label");

                label1.innerHTML = "Raison :";

                label2 = document.createElement("label");

                label2.innerHTML = "Détails :";

                div = document.createElement("div");

                div.appendChild(label1);
                div.appendChild(select);
                div.appendChild(label2);
                div.appendChild(textarea);

                _context21.next = 60;
                return swal({
                  title: typeof onlyValue === "boolean" && onlyValue === true ? "Voulez-vous \xE9diter la raison ?" : "Voulez-vous annuler l'acte manag\xE9rial de " + row.driverName + " ?",
                  content: {
                    element: div
                  },
                  icon: "warning",
                  dangerMode: true,
                  buttons: ["Annuler", "Valider"]
                });

              case 60:
                cancel = _context21.sent;
                data = {
                  managerActCancelReason: value,
                  managerActCancelReasonDetails: details
                };

                if (!(cancel && (!value || !details))) {
                  _context21.next = 65;
                  break;
                }

                Notiflix.Notify.warning("Veuillez choisir une raison et renseigner les détails de la raison avant de valider !");
                return _context21.abrupt("return");

              case 65:
                if (!(value && details && cancel == true)) {
                  _context21.next = 87;
                  break;
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context21.prev = 67;
                _context21.next = 70;
                return DepasService.customPost("cancelManagerAct/" + row._id, data);

              case 70:
                response = _context21.sent;

                Notiflix.Loading.remove();

                if (!(response.success === true)) {
                  _context21.next = 78;
                  break;
                }

                Notiflix.Notify.success(typeof onlyValue === "boolean" && onlyValue === true ? "La raison a été modifiée." : "L'acte managérial a été annulé.");
                _context21.next = 76;
                return vm.refresh();

              case 76:
                _context21.next = 80;
                break;

              case 78:
                Notiflix.Notify.failure("Erreur lors de l'annulation.");
                return _context21.abrupt("return");

              case 80:
                _context21.next = 87;
                break;

              case 82:
                _context21.prev = 82;
                _context21.t1 = _context21["catch"](67);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue coté serveur. Contactez le support.");
                return _context21.abrupt("return");

              case 87:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this, [[16, 32, 36, 44], [37,, 39, 43], [67, 82]]);
      }));

      return function (_x21) {
        return _ref21.apply(this, arguments);
      };
    }();

    vm.reactivateManagerAct = function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(row) {
        var willReactivate, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return swal({
                  //title: "",
                  text: "Voulez-vous r\xE9activer l'acte manag\xE9rial de " + row.managerName + " (" + row.managerEmail + ") ?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                    cancel: "Non",
                    confirm: "Oui"
                  }
                });

              case 2:
                willReactivate = _context22.sent;

                if (!(willReactivate == true)) {
                  _context22.next = 25;
                  break;
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context22.prev = 5;
                _context22.next = 8;
                return DepasService.customPost("reactivateManagerAct/" + row._id);

              case 8:
                response = _context22.sent;

                Notiflix.Loading.remove();

                if (!(response.success === true)) {
                  _context22.next = 16;
                  break;
                }

                Notiflix.Notify.success("L'acte managérial a été réactivé.");
                _context22.next = 14;
                return vm.refresh();

              case 14:
                _context22.next = 18;
                break;

              case 16:
                Notiflix.Notify.failure("Erreur lors de la réactivation.");
                return _context22.abrupt("return");

              case 18:
                _context22.next = 25;
                break;

              case 20:
                _context22.prev = 20;
                _context22.t0 = _context22["catch"](5);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Une erreur est survenue coté serveur. Contactez le support.");
                return _context22.abrupt("return");

              case 25:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this, [[5, 20]]);
      }));

      return function (_x23) {
        return _ref22.apply(this, arguments);
      };
    }();

    vm.isLvr = ["super-admin", "super-operator", "operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuperAdmin = ["super-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    var writeDepa = vm.isAdmin || vm.isLvr || $rootScope.$user.rights && $rootScope.$user.rights.depa && $rootScope.$user.rights.depa.write && $rootScope.$user.rights.depa.write === true;

    var validateManagerAct = writeDepa || $rootScope.$user.rights && $rootScope.$user.rights.managerAct && $rootScope.$user.rights.managerAct.validate === true;

    vm.edit = null;

    var damageGroup = [AgGridService.date("dateDamage", "Date", 100), AgGridService.text("typeOfAccidentName", "Type", 150)];

    vm.setGridColumns = function () {
      var columnsDepa = [AgGridService.button("btInfo", "Fiche récap.", vm.displayInfo, _this, {
        width: 110
      }), AgGridService.button("btDriverInfo", "Fiche conducteur", vm.displayDriverInfo, _this, {
        width: 110
      }), AgGridService.text("statusName", "Statut", 110)];

      var columnsManagerAct = [AgGridService.text("managerName", "NOM prénom", 150), AgGridService.text("managerEmail", "Email", 200, {
        columnGroupShow: "open"
      }), AgGridService.text("managerActSent", "Envoyé ?", 110), AgGridService.date("managerActDate", "Date de l'acte managérial", 150, {
        columnGroupShow: "open"
      }), AgGridService.text("managerActMethodName", "L'acte managérial a eu lieu", 150, {
        columnGroupShow: "open"
      }), AgGridService.bool("managerActSigned", "Rapport signé", 100, {
        columnGroupShow: "open"
      }), AgGridService.text("managerActComment", "Commentaire du manageur", 200, {
        columnGroupShow: "open"
      }), AgGridService.date("emailReminderManagerActDate1", "Relance 1", 100, {
        columnGroupShow: "open"
      }), AgGridService.date("emailReminderManagerActDate2", "Relance 2", 100, {
        columnGroupShow: "open"
      }), AgGridService.date("emailReminderManagerActDate3", "Relance 3", 100, {
        columnGroupShow: "open"
      }), AgGridService.date("emailReminderManagerActDateLast", "1er export Final", 100, {
        columnGroupShow: "open"
      })];

      if (validateManagerAct === true) {
        columnsManagerAct.push(AgGridService.button("btOpenManagerAct", "Ouvrir le lien de l'acte", vm.openManagerAct, _this, {
          width: 200
        }));
      }

      if (writeDepa === true) {
        columnsManagerAct.push(AgGridService.button("btSendManagerAct", "Renvoyer le lien de l'acte", vm.resendManagerAct, _this, {
          width: 200,
          columnGroupShow: "open"
        }));
      }

      if (vm.isLvr === true || vm.isAdmin === true) {
        columnsManagerAct.push(AgGridService.button("btCancelManagerAct", "Annuler/Réactiver l'acte", vm.cancelManagerAct, _this, {
          width: 200,
          columnGroupShow: "open"
        }));
        columnsManagerAct.push(AgGridService.button("btManagerActReasonCancel", "Modifier la raison d'annulation", vm.editManagerActCancelReason, _this, {
          width: 200,
          columnGroupShow: "open"
        }));
      }

      var columnsDriver = [AgGridService.text("groupName", "Groupe", 200, {
        columnGroupShow: "open"
      }), AgGridService.text("driver.internalNumber", "Matricule", 100, {
        columnGroupShow: "open"
      })];

      var columnsMissing1 = [AgGridService.date("meeting1MissingDate", "Date ", 150)];
      var columnsMissing2 = [AgGridService.date("meeting2MissingDate", "Date", 150)];
      var columnsMissing3 = [AgGridService.date("meeting3MissingDate", "Date", 150)];
      var columnsMissingLast = [AgGridService.date("meetingLastMissingDate", "Date", 150)];

      if (vm.isLvr === true) {
        columnsDepa.unshift(AgGridService.button("btCancel", "Annuler", vm.cancel, _this, {
          width: 95
        }));
        columnsDepa.unshift(AgGridService.button("btScheduleDepa", "Suivi du RDV", vm.scheduleDepa, _this, {
          //columnGroupShow: "open",
          width: 130
        }));
        columnsDepa.push(AgGridService.button("btReasonCancel", "Raison d'annulation ", vm.editCancel, _this, {
          columnGroupShow: "open",
          width: 200
        }));
        columnsDepa.push(AgGridService.text("reasonCancelName", "Raison d'annulation ", 100, {
          columnGroupShow: "open"
        }));
        columnsDepa.push(AgGridService.text("reasonCancelDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing1.push(AgGridService.button("btReasonDriverNotAvailable1", "Raison", vm.editNotAvailable1, _this, {
          columnGroupShow: "open",
          width: 200
        }));
        columnsMissing2.push(AgGridService.button("btReasonDriverNotAvailable2", "Raison", vm.editNotAvailable2, _this, {
          columnGroupShow: "open",
          width: 200
        }));
        columnsMissing3.push(AgGridService.button("btReasonDriverNotAvailable3", "Raison", vm.editNotAvailable3, _this, {
          columnGroupShow: "open",
          width: 200
        }));
        columnsMissingLast.push(AgGridService.button("btReasonDriverNotAvailableLast", "Raison", vm.editNotAvailableLast, _this, {
          columnGroupShow: "open",
          width: 200
        }));
        columnsMissing1.push(AgGridService.text("meeting1MissingReasonName", "Raison", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing2.push(AgGridService.text("meeting2MissingReasonName", "Raison", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing3.push(AgGridService.text("meeting3MissingReasonName", "Raison", 100, {
          columnGroupShow: "open"
        }));
        columnsMissingLast.push(AgGridService.text("meetingLastMissingReasonName", "Raison", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing1.push(AgGridService.text("meeting1MissingReasonDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing2.push(AgGridService.text("meeting2MissingReasonDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing3.push(AgGridService.text("meeting3MissingReasonDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
        columnsMissingLast.push(AgGridService.text("meetingLastMissingReasonDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
      } else {
        if (vm.isAdmin === true) {
          columnsDepa.unshift(AgGridService.button("btCancel", "Annuler", vm.cancel, _this, {
            width: 95
          }));
        }
        if (writeDepa === true) {
          columnsDepa.unshift(AgGridService.button("btScheduleDepa", "Suivi du RDV", vm.scheduleDepa, _this, {
            //columnGroupShow: "open",
            width: 130
          }));
        }
        columnsDepa.push(AgGridService.text("reasonCancelName", "Raison d'annulation ", 100, {
          columnGroupShow: "open"
        }));
        columnsDepa.push(AgGridService.text("reasonCancelDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing1.push(AgGridService.text("meeting1MissingReasonName", "Raison", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing1.push(AgGridService.text("meeting1MissingReasonDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing2.push(AgGridService.text("meeting2MissingReasonName", "Raison", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing2.push(AgGridService.text("meeting2MissingReasonDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing3.push(AgGridService.text("meeting3MissingReasonName", "Raison", 100, {
          columnGroupShow: "open"
        }));
        columnsMissing3.push(AgGridService.text("meeting3MissingReasonDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
        columnsMissingLast.push(AgGridService.text("meetingLastMissingReasonName", "Raison", 100, {
          columnGroupShow: "open"
        }));
        columnsMissingLast.push(AgGridService.text("meetingLastMissingReasonDetails", "Détails de la raison ", 100, {
          columnGroupShow: "open"
        }));
      }

      var columnDefs1 = [AgGridService.group("DEPA", columnsDepa), AgGridService.group("Sinistre associé", damageGroup), AgGridService.group("RDV", [AgGridService.date("slotStart", "Date", 100), AgGridService.hour("slotStart", "Début", 85), AgGridService.hour("slotEnd", "Fin", 85, {
        columnGroupShow: "open"
      }), AgGridService.text("phone", "Téléphone (RDV)", 100, {
        columnGroupShow: "open"
      }), AgGridService.text("emailToUse", "Email (lien)", 200, {
        columnGroupShow: "open"
      }), AgGridService.text("phoneToUse", "Téléphone (lien)", 100, {
        columnGroupShow: "open"
      })]), AgGridService.group("Collaborateur associé au sinistre", columnsDriver), AgGridService.group($rootScope.defaultManagerLabel + " du collaborateur", columnsManagerAct), AgGridService.number("missingCount", "Nombre de RDV manqués pour ce DEPA", 100), AgGridService.number("driverNbMissingDepas", "Nombre de RDV manqués pour ce conducteur (sur 12 mois)", 100), AgGridService.group("RDV manqué #1", columnsMissing1), AgGridService.group("RDV manqué #2", columnsMissing2), AgGridService.group("RDV manqué #3", columnsMissing3), AgGridService.group("RDV manqué #Dernier", columnsMissingLast), AgGridService.group("Relances", [AgGridService.date("emailReminderDate1", "Relance 1", 100), AgGridService.date("emailReminderDate2", "Relance 2", 100), AgGridService.date("emailReminderDate3", "Relance 3", 100), AgGridService.date("emailReminderDateLast", "1er export Final", 100), AgGridService.text("note", "Commentaires")])];

      if (vm.isLvr === true) {
        var lvrColumns = [AgGridService.button("btForm", "Form.", vm.form, _this, {
          width: 75
        }), AgGridService.button("btNotAvailable", "Reporter", vm.notAvailable, _this, {
          width: 95
        }), AgGridService.button("btTrainingMode", "Entrainement", vm.trainingForm, _this, {
          width: 150
        }), AgGridService.text("operatorName", "Conseiller/ère", 150)];
        columnDefs1.unshift(AgGridService.group("LVR", lvrColumns));
      }

      vm.columnDefs1 = columnDefs1;

      vm.columnDefs2 = [AgGridService.text("typeOfAccidentName", "Type"), AgGridService.text("keywords", "Mots clés"), AgGridService.text("circumstance", "Circonstances"), AgGridService.text("evitability", "Evitabilité"), AgGridService.text("isEvitable", "Evitable pour le conducteur ?"), AgGridService.text("isEvitableLvr", "Evitable pour LVR ?"), AgGridService.text("advices", "Conseils LVR"), AgGridService.text("interviewEvaluation", "Evaluation de l'entretien"), AgGridService.text("withInjuries", "Corporel ?"), AgGridService.text("withPsychologicalImpact", "Avec impact psychologique ?"), AgGridService.date("dateDamage", "Date Sinistre", 110), AgGridService.date("slotStart", "Date RDV", 110), AgGridService.group($rootScope.defaultManagerLabel + " du collaborateur", columnsManagerAct)];

      vm.columnDefs3 = [AgGridService.text("statusName", "Statut"), AgGridService.text("groupName", "Groupe du collaborateur"), AgGridService.text("emailToUse", "Email", 150), AgGridService.text("nbDays", "Nombre de jours écoulés", 110), AgGridService.date("creationDate", "Date Création"), AgGridService.date("dateDamage", "Date Sinistre", 110), AgGridService.group("RDV manqué #1", columnsMissing1), AgGridService.group("RDV manqué #2", columnsMissing2), AgGridService.group("RDV manqué #3", columnsMissing3), AgGridService.group("RDV manqué #Dernier", columnsMissingLast), AgGridService.group("Relances", [AgGridService.date("emailReminderDate1", "Relance 1", 100), AgGridService.date("emailReminderDate2", "Relance 2", 100), AgGridService.date("emailReminderDate3", "Relance 3", 100), AgGridService.date("emailReminderDateLast", "1er export final", 100), AgGridService.text("note", "Commentaires")])];

      if (vm.customer.sendManagerAct === true) {
        vm.columnDefs4 = [AgGridService.text("typeOfAccidentName", "Type"), AgGridService.date("dateDamage", "Date Sinistre", 110), AgGridService.date("slotStart", "Date RDV", 110), AgGridService.group($rootScope.defaultManagerLabel + " du collaborateur", columnsManagerAct)];
      }

      vm.columnDefs1.unshift(AgGridService.text("driverName", "Collaborateur", 150, {
        pinned: "left"
      }));
      vm.columnDefs2.unshift(AgGridService.text("driverName", "Collaborateur", 150, {
        pinned: "left"
      }));
      vm.columnDefs3.unshift(AgGridService.text("driverName", "Collaborateur", 150, {
        pinned: "left"
      }));
      if (vm.columnDefs4) {
        vm.columnDefs4.unshift(AgGridService.text("driverName", "Collaborateur", 150, {
          pinned: "left"
        }));
      }
      vm.columnDefs1.unshift(AgGridService.text("damageName", "Réf.", 100, { pinned: "left" }));
      vm.columnDefs2.unshift(AgGridService.text("damageName", "Réf.", 100, { pinned: "left" }));
      vm.columnDefs3.unshift(AgGridService.text("damageName", "Réf.", 100, { pinned: "left" }));
      if (vm.columnDefs4) {
        vm.columnDefs4.unshift(AgGridService.text("damageName", "Réf.", 100, { pinned: "left" }));
      }

      vm.columnDefs2.unshift(AgGridService.button("btDriverInfo", "Fiche conducteur", vm.displayDriverInfo, _this, {
        width: 110
      }));
      vm.columnDefs2.unshift(AgGridService.button("btInfo", "Fiche récap.", vm.displayInfo, _this, {
        width: 110
      }));
      vm.columnDefs3.unshift(AgGridService.button("btDriverInfo", "Fiche conducteur", vm.displayDriverInfo, _this, {
        width: 110
      }));
      vm.columnDefs3.unshift(AgGridService.button("btInfo", "Fiche récap.", vm.displayInfo, _this, {
        width: 110
      }));
      if (vm.columnDefs4) {
        vm.columnDefs4.unshift(AgGridService.button("btDriverInfo", "Fiche conducteur", vm.displayDriverInfo, _this, {
          width: 110
        }));
        vm.columnDefs4.unshift(AgGridService.button("btInfo", "Fiche récap.", vm.displayInfo, _this, {
          width: 110
        }));
      }
      if (writeDepa === true) {
        vm.columnDefs2.unshift(AgGridService.button("btScheduleDepa", "Suivi du RDV", vm.scheduleDepa, _this, {
          width: 130
        }));
        vm.columnDefs3.unshift(AgGridService.button("btScheduleDepa", "Suivi du RDV", vm.scheduleDepa, _this, {
          width: 130
        }));
      }

      if (vm.isSuperAdmin) {
        vm.columnDefs1.unshift(AgGridService.checkbox());
      }
    };

    vm.gridEvent = function (value) {
      if (value.type == "rowDoubleClicked") {
        vm.edit(value.data);
      } else if (value.type == "exportButton") {
        if (vm.runExport) {
          vm.runExport();
        }
      }
    };

    vm.bulkActionChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.t0 = vm.bulkAction;
              _context23.next = _context23.t0 === "1" ? 3 : _context23.t0 === "2" ? 6 : 9;
              break;

            case 3:
              _context23.next = 5;
              return vm.bulkCancelManagerActs();

            case 5:
              return _context23.abrupt("break", 9);

            case 6:
              _context23.next = 8;
              return vm.bulkReactivateManagerActs();

            case 8:
              return _context23.abrupt("break", 9);

            case 9:
              vm.bulkAction = "0";

            case 10:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, _this);
    }));

    vm.bulkCancelManagerActs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
      var rows, eligible, value, details, select, emptyOption, _iteratorNormalCompletion23, _didIteratorError23, _iteratorError23, _iterator23, _step23, reason, option, textarea, label1, label2, div, confirm, successCount, errorCount, _iteratorNormalCompletion24, _didIteratorError24, _iteratorError24, _iterator24, _step24, _row, response;

      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              rows = vm.rowsSelected;

              if (!(!rows || rows.length === 0)) {
                _context24.next = 4;
                break;
              }

              Notiflix.Notify.warning("Aucune ligne sélectionnée.");
              return _context24.abrupt("return");

            case 4:
              eligible = rows.filter(function (r) {
                return r.data && r.data.managerActCancelled !== true && r.data.btCancelManagerAct;
              });

              if (!(eligible.length === 0)) {
                _context24.next = 8;
                break;
              }

              Notiflix.Notify.warning("Aucun acte managérial à annuler parmi les lignes sélectionnées (déjà annulés ou sans acte).");
              return _context24.abrupt("return");

            case 8:
              value = null;
              details = null;
              select = document.createElement("select");

              select.className = "form-control";
              emptyOption = document.createElement("option");

              emptyOption.innerHTML = "";
              emptyOption.value = "";
              select.appendChild(emptyOption);
              _iteratorNormalCompletion23 = true;
              _didIteratorError23 = false;
              _iteratorError23 = undefined;
              _context24.prev = 19;
              _iterator23 = vm.reasonsManagerActCancelled[Symbol.iterator]();

            case 21:
              if (_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done) {
                _context24.next = 32;
                break;
              }

              reason = _step23.value;

              if (!reason.value.endsWith("Auto")) {
                _context24.next = 25;
                break;
              }

              return _context24.abrupt("continue", 29);

            case 25:
              option = document.createElement("option");

              option.innerHTML = reason.name;
              option.value = reason.value;
              select.appendChild(option);

            case 29:
              _iteratorNormalCompletion23 = true;
              _context24.next = 21;
              break;

            case 32:
              _context24.next = 38;
              break;

            case 34:
              _context24.prev = 34;
              _context24.t0 = _context24["catch"](19);
              _didIteratorError23 = true;
              _iteratorError23 = _context24.t0;

            case 38:
              _context24.prev = 38;
              _context24.prev = 39;

              if (!_iteratorNormalCompletion23 && _iterator23.return) {
                _iterator23.return();
              }

            case 41:
              _context24.prev = 41;

              if (!_didIteratorError23) {
                _context24.next = 44;
                break;
              }

              throw _iteratorError23;

            case 44:
              return _context24.finish(41);

            case 45:
              return _context24.finish(38);

            case 46:
              select.onchange = function (e) {
                value = e.target.value;
              };

              textarea = document.createElement("textarea");

              textarea.className = "form-control";
              textarea.onchange = function (e) {
                details = e.target.value;
              };

              label1 = document.createElement("label");

              label1.innerHTML = "Raison :";
              label2 = document.createElement("label");

              label2.innerHTML = "Détails :";
              div = document.createElement("div");

              div.appendChild(label1);
              div.appendChild(select);
              div.appendChild(label2);
              div.appendChild(textarea);

              _context24.next = 61;
              return swal({
                title: "Annuler " + eligible.length + " acte(s) manag\xE9rial(aux) ?",
                content: { element: div },
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Valider"]
              });

            case 61:
              confirm = _context24.sent;

              if (confirm) {
                _context24.next = 64;
                break;
              }

              return _context24.abrupt("return");

            case 64:
              if (!(!value || !details)) {
                _context24.next = 67;
                break;
              }

              Notiflix.Notify.warning("Veuillez choisir une raison et renseigner les détails avant de valider !");
              return _context24.abrupt("return");

            case 67:

              Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
              successCount = 0;
              errorCount = 0;
              _iteratorNormalCompletion24 = true;
              _didIteratorError24 = false;
              _iteratorError24 = undefined;
              _context24.prev = 73;
              _iterator24 = eligible[Symbol.iterator]();

            case 75:
              if (_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done) {
                _context24.next = 91;
                break;
              }

              _row = _step24.value;
              _context24.prev = 77;
              _context24.next = 80;
              return DepasService.customPost("cancelManagerAct/" + _row.data._id, {
                managerActCancelReason: value,
                managerActCancelReasonDetails: details
              });

            case 80:
              response = _context24.sent;

              if (response.success === true) {
                successCount++;
              } else {
                errorCount++;
              }
              _context24.next = 88;
              break;

            case 84:
              _context24.prev = 84;
              _context24.t1 = _context24["catch"](77);

              console.error(_context24.t1);
              errorCount++;

            case 88:
              _iteratorNormalCompletion24 = true;
              _context24.next = 75;
              break;

            case 91:
              _context24.next = 97;
              break;

            case 93:
              _context24.prev = 93;
              _context24.t2 = _context24["catch"](73);
              _didIteratorError24 = true;
              _iteratorError24 = _context24.t2;

            case 97:
              _context24.prev = 97;
              _context24.prev = 98;

              if (!_iteratorNormalCompletion24 && _iterator24.return) {
                _iterator24.return();
              }

            case 100:
              _context24.prev = 100;

              if (!_didIteratorError24) {
                _context24.next = 103;
                break;
              }

              throw _iteratorError24;

            case 103:
              return _context24.finish(100);

            case 104:
              return _context24.finish(97);

            case 105:

              Notiflix.Loading.remove();

              if (successCount > 0) {
                Notiflix.Notify.success(successCount + " acte(s) annul\xE9(s) avec succ\xE8s.");
              }
              if (errorCount > 0) {
                Notiflix.Notify.failure(errorCount + " erreur(s) lors de l'annulation.");
              }

              _context24.next = 110;
              return vm.refresh();

            case 110:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, _this, [[19, 34, 38, 46], [39,, 41, 45], [73, 93, 97, 105], [77, 84], [98,, 100, 104]]);
    }));

    vm.bulkReactivateManagerActs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
      var rows, eligible, confirm, successCount, errorCount, _iteratorNormalCompletion25, _didIteratorError25, _iteratorError25, _iterator25, _step25, _row2, response;

      return regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              rows = vm.rowsSelected;

              if (!(!rows || rows.length === 0)) {
                _context25.next = 4;
                break;
              }

              Notiflix.Notify.warning("Aucune ligne sélectionnée.");
              return _context25.abrupt("return");

            case 4:
              eligible = rows.filter(function (r) {
                return r.data && r.data.managerActCancelled === true;
              });

              if (!(eligible.length === 0)) {
                _context25.next = 8;
                break;
              }

              Notiflix.Notify.warning("Aucun acte managérial à réactiver parmi les lignes sélectionnées (non annulés ou sans acte).");
              return _context25.abrupt("return");

            case 8:
              _context25.next = 10;
              return swal({
                title: "R\xE9activer " + eligible.length + " acte(s) manag\xE9rial(aux) ?",
                icon: "warning",
                dangerMode: true,
                buttons: { cancel: "Non", confirm: "Oui" }
              });

            case 10:
              confirm = _context25.sent;

              if (confirm) {
                _context25.next = 13;
                break;
              }

              return _context25.abrupt("return");

            case 13:

              Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
              successCount = 0;
              errorCount = 0;
              _iteratorNormalCompletion25 = true;
              _didIteratorError25 = false;
              _iteratorError25 = undefined;
              _context25.prev = 19;
              _iterator25 = eligible[Symbol.iterator]();

            case 21:
              if (_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done) {
                _context25.next = 37;
                break;
              }

              _row2 = _step25.value;
              _context25.prev = 23;
              _context25.next = 26;
              return DepasService.customPost("reactivateManagerAct/" + _row2.data._id);

            case 26:
              response = _context25.sent;

              if (response.success === true) {
                successCount++;
              } else {
                errorCount++;
              }
              _context25.next = 34;
              break;

            case 30:
              _context25.prev = 30;
              _context25.t0 = _context25["catch"](23);

              console.error(_context25.t0);
              errorCount++;

            case 34:
              _iteratorNormalCompletion25 = true;
              _context25.next = 21;
              break;

            case 37:
              _context25.next = 43;
              break;

            case 39:
              _context25.prev = 39;
              _context25.t1 = _context25["catch"](19);
              _didIteratorError25 = true;
              _iteratorError25 = _context25.t1;

            case 43:
              _context25.prev = 43;
              _context25.prev = 44;

              if (!_iteratorNormalCompletion25 && _iterator25.return) {
                _iterator25.return();
              }

            case 46:
              _context25.prev = 46;

              if (!_didIteratorError25) {
                _context25.next = 49;
                break;
              }

              throw _iteratorError25;

            case 49:
              return _context25.finish(46);

            case 50:
              return _context25.finish(43);

            case 51:

              Notiflix.Loading.remove();

              if (successCount > 0) {
                Notiflix.Notify.success(successCount + " acte(s) r\xE9activ\xE9(s) avec succ\xE8s.");
              }
              if (errorCount > 0) {
                Notiflix.Notify.failure(errorCount + " erreur(s) lors de la r\xE9activation.");
              }

              _context25.next = 56;
              return vm.refresh();

            case 56:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, _this, [[19, 39, 43, 51], [23, 30], [44,, 46, 50]]);
    }));

    vm.runExport = function () {
      var sheets = [];

      var maxTab = 3;
      var currentTab = 0;
      while (currentTab < maxTab) {
        var sheet = vm.exportSheet[currentTab]();
        sheets.push(sheet);
        currentTab += 1;
      }

      vm.gridApi[0].exportMultipleSheetsAsExcel({
        data: sheets,
        fileName: "DEPAs"
      });
    };

    vm.gridReady = function (api, exportSheet, index) {
      if (!vm.gridApi) {
        vm.gridApi = {};
        vm.exportSheet = {};
      }
      vm.gridApi[index] = api;
      vm.exportSheet[index] = exportSheet;
    };

    vm.rowsSelected = [];

    vm.refresh = function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(params) {
        var today, withDepaSlot, data, damages, depas, managerActValidationShortIds, shortIds, _index, response, accessibleShortIds, _iteratorNormalCompletion26, _didIteratorError26, _iteratorError26, _iterator26, _step26, shortId, depasById, _iteratorNormalCompletion27, _didIteratorError27, _iteratorError27, _iterator27, _step27, _depa, rawData, index, damage, depa, managerActReasonCancelItem, reasonCancelItem, reasonMissing1Item, reasonMissing2Item, reasonMissing3Item, reasonMissingLastItem, typeOfAccidentData, damageManager, blocked, active, now, dateDamage, _index2, groupId, manager, managerActMethod;

        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                if ($rootScope.$selectedCustomerId) {
                  _context26.next = 2;
                  break;
                }

                return _context26.abrupt("return");

              case 2:

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                _context26.next = 5;
                return CustomersService.findById({
                  _id: $rootScope.$selectedCustomerId.replace("$", ""),
                  filter: {
                    fields: {
                      sendManagerAct: true,
                      visibleDamageTypes: true
                    }
                  }
                });

              case 5:
                vm.customer = _context26.sent;


                vm.setGridColumns();

                _context26.next = 9;
                return TelematicSyncConfigsService.findOne({
                  filter: {
                    where: {
                      customerId: $rootScope.$selectedCustomerId.replace("$", "")
                    },
                    fields: { software: true, fields: true }
                  }
                });

              case 9:
                vm.telematicSyncConfig = _context26.sent;

                if (!(vm.telematicSyncConfig && vm.telematicSyncConfig.software)) {
                  _context26.next = 14;
                  break;
                }

                _context26.next = 13;
                return CustomListsService.getNameByValue("telematicSoftware", vm.telematicSyncConfig.software);

              case 13:
                vm.softwareName = _context26.sent;

              case 14:
                _context26.next = 16;
                return SyncConfigsService.findOne({
                  filter: {
                    where: {
                      customerId: $rootScope.$selectedCustomerId.replace("$", "")
                    },
                    fields: { software: true }
                  }
                });

              case 16:
                vm.syncConfig = _context26.sent;
                today = moment().endOf("day");
                withDepaSlot = vm.withDepaSlot;
                _context26.prev = 19;

                if (params && params.from && params.to) {
                  vm.from = params.from;
                  vm.to = params.to;
                }

                if (!vm.from || !vm.to) {
                  vm.from = moment().subtract(12, "months").startOf("month").toDate();
                  vm.to = moment().endOf("month").toDate();
                }

                _context26.next = 24;
                return Promise.all([DepasService.loadForPeriod({
                  from: vm.from,
                  to: vm.to,
                  withDepaSlot: withDepaSlot,
                  damageFields: ["_id", "dateDamage", "name", "typeOfAccident", "driverId", "managerId", "depaId", "vehicleId", "docs", "docsBilling", "circumstance", "externalVehicleName"],
                  depaFields: ["_id", "status", "reasonCancel", "reasonCancelDetails", "meeting1MissingDate", "meeting1MissingReason", "meeting1MissingReasonDetails", "meeting2MissingDate", "meeting2MissingReason", "meeting2MissingReasonDetails", "meeting3MissingDate", "meeting3MissingReason", "meeting3MissingReasonDetails", "meetingLastMissingDate", "meetingLastMissingReason", "meetingLastMissingReasonDetails", "slot", "damageId", "emailToUse", "phoneToUse", "phone", "missingCount", "answers.commentDetails", "answers.commentSuggestions", "answers.commentGlass", "answers.commentAdvices", "answers.commentNotEvitable", "answers.interviewEvaluation", "answers.isEvitable", "answers.isEvitableLvr", "answers.keywords", "answers.commentOnDriver", "answers.accidentOrigin", "answers.typeOfAccidentV2", "answers.typeContract", "answers.notRecognizeFacts", "answers.dontRememberButRecognizeFacts", "answers.dateDamage", "answers.firstName", "answers.lastName", "answers.withInjuries", "answers.withPsychologicalImpact", "managerAct", "managerActCancelled", "managerActCancelReason", "managerActCancelReasonDetails", "creationDate", "emailReminderDate1", "emailReminderDate2", "emailReminderDate3", "emailReminderDateLast", "emailReminderManagerActDate1", "emailReminderManagerActDate2", "emailReminderManagerActDate3", "emailReminderManagerActDateLast", "note", "docs", "shortId"]
                }), CustomListsService.getSelectArray("typeOfAccidentV2"), CustomListsService.getSelectArray("reasonDepaCancelled"), CustomListsService.getSelectArray("reasonDriverNotAvailable"), CustomListsService.getSelectArray("managerActMethod"), CustomListsService.getSelectArray("reasonManagerActCancelled")]);

              case 24:
                data = _context26.sent;
                damages = data[0].damages;
                depas = data[0].depas;
                managerActValidationShortIds = new Set();

                if (!(validateManagerAct === true)) {
                  _context26.next = 64;
                  break;
                }

                _context26.prev = 29;
                shortIds = depas.filter(function (depa) {
                  return depa.shortId && depa.managerAct && !depa.managerAct.actDate && depa.managerActCancelled !== true;
                }).map(function (depa) {
                  return depa.shortId;
                });
                _index = 0;

              case 32:
                if (!(_index < shortIds.length)) {
                  _context26.next = 59;
                  break;
                }

                _context26.next = 35;
                return DepasService.customPost("managerActValidationAccess", {
                  shortIds: shortIds.slice(_index, _index + 500)
                });

              case 35:
                response = _context26.sent;
                accessibleShortIds = response && response.data && response.data.shortIds ? response.data.shortIds : [];
                _iteratorNormalCompletion26 = true;
                _didIteratorError26 = false;
                _iteratorError26 = undefined;
                _context26.prev = 40;

                for (_iterator26 = accessibleShortIds[Symbol.iterator](); !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
                  shortId = _step26.value;

                  managerActValidationShortIds.add(shortId);
                }
                _context26.next = 48;
                break;

              case 44:
                _context26.prev = 44;
                _context26.t0 = _context26["catch"](40);
                _didIteratorError26 = true;
                _iteratorError26 = _context26.t0;

              case 48:
                _context26.prev = 48;
                _context26.prev = 49;

                if (!_iteratorNormalCompletion26 && _iterator26.return) {
                  _iterator26.return();
                }

              case 51:
                _context26.prev = 51;

                if (!_didIteratorError26) {
                  _context26.next = 54;
                  break;
                }

                throw _iteratorError26;

              case 54:
                return _context26.finish(51);

              case 55:
                return _context26.finish(48);

              case 56:
                _index += 500;
                _context26.next = 32;
                break;

              case 59:
                _context26.next = 64;
                break;

              case 61:
                _context26.prev = 61;
                _context26.t1 = _context26["catch"](29);

                console.error("Impossible de vérifier les droits de validation des actes managériaux.", _context26.t1);

              case 64:
                vm.typeOfAccidentList = data[1];
                vm.reasonsDepaCancelled = data[2];
                vm.reasonsDriverNotAvailable = data[3];
                vm.managerActMethodList = data[4];
                vm.reasonsManagerActCancelled = data[5];

                depasById = {};
                _iteratorNormalCompletion27 = true;
                _didIteratorError27 = false;
                _iteratorError27 = undefined;
                _context26.prev = 73;

                for (_iterator27 = depas[Symbol.iterator](); !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  _depa = _step27.value;

                  depasById["$" + _depa._id] = _depa;
                }

                _context26.next = 81;
                break;

              case 77:
                _context26.prev = 77;
                _context26.t2 = _context26["catch"](73);
                _didIteratorError27 = true;
                _iteratorError27 = _context26.t2;

              case 81:
                _context26.prev = 81;
                _context26.prev = 82;

                if (!_iteratorNormalCompletion27 && _iterator27.return) {
                  _iterator27.return();
                }

              case 84:
                _context26.prev = 84;

                if (!_didIteratorError27) {
                  _context26.next = 87;
                  break;
                }

                throw _iteratorError27;

              case 87:
                return _context26.finish(84);

              case 88:
                return _context26.finish(81);

              case 89:
                rawData = [];

                vm.events = [];

                index = 0;

              case 92:
                if (!(index < damages.length)) {
                  _context26.next = 216;
                  break;
                }

                damage = damages[index];

                if (damage.depaId) {
                  _context26.next = 96;
                  break;
                }

                return _context26.abrupt("continue", 213);

              case 96:
                depa = depasById[damage.depaId];

                if (!(!depa && !withDepaSlot)) {
                  _context26.next = 101;
                  break;
                }

                _context26.next = 100;
                return DepasService.findById({ _id: damage.depaId });

              case 100:
                depa = _context26.sent;

              case 101:
                if (depa) {
                  _context26.next = 103;
                  break;
                }

                return _context26.abrupt("continue", 213);

              case 103:

                if (depa.slot && depa.slot.start) {
                  depa.slotStart = depa.slot.start;
                }
                if (depa.slot && depa.slot.end) {
                  depa.slotEnd = depa.slot.end;
                }

                managerActReasonCancelItem = vm.reasonsManagerActCancelled.find(function (item) {
                  return item.value === depa.managerActCancelReason;
                });

                if (managerActReasonCancelItem) {
                  depa.managerActCancelReasonName = managerActReasonCancelItem.name;
                  depa.btManagerActReasonCancel = {
                    text: "<i class=\"fa fa-edit\"></i> " + depa.managerActCancelReasonName,
                    color: "custom"
                  };
                }

                reasonCancelItem = vm.reasonsDepaCancelled.find(function (item) {
                  return item.value === depa.reasonCancel;
                });

                if (reasonCancelItem) {
                  depa.reasonCancelName = reasonCancelItem.name;
                  depa.btReasonCancel = {
                    text: "<i class=\"fa fa-edit\"></i> " + depa.reasonCancelName,
                    color: "custom"
                  };
                }
                reasonMissing1Item = vm.reasonsDriverNotAvailable.find(function (item) {
                  return item.value === depa.meeting1MissingReason;
                });

                if (reasonMissing1Item) {
                  depa.meeting1MissingReasonName = reasonMissing1Item.name;
                  depa.btReasonDriverNotAvailable1 = {
                    text: "<i class=\"fa fa-edit\"></i> " + depa.meeting1MissingReasonName,
                    color: "custom"
                  };
                }
                reasonMissing2Item = vm.reasonsDriverNotAvailable.find(function (item) {
                  return item.value === depa.meeting2MissingReason;
                });

                if (reasonMissing2Item) {
                  depa.meeting2MissingReasonName = reasonMissing2Item.name;
                  depa.btReasonDriverNotAvailable2 = {
                    text: "<i class=\"fa fa-edit\"></i> " + depa.meeting2MissingReasonName,
                    color: "custom"
                  };
                }
                reasonMissing3Item = vm.reasonsDriverNotAvailable.find(function (item) {
                  return item.value === depa.meeting3MissingReason;
                });

                if (reasonMissing3Item) {
                  depa.meeting3MissingReasonName = reasonMissing3Item.name;
                  depa.btReasonDriverNotAvailable3 = {
                    text: "<i class=\"fa fa-edit\"></i> " + depa.meeting3MissingReasonName,
                    color: "custom"
                  };
                }
                reasonMissingLastItem = vm.reasonsDriverNotAvailable.find(function (item) {
                  return item.value === depa.meetingLastMissingReason;
                });

                if (reasonMissingLastItem) {
                  depa.meetingLastMissingReasonName = reasonMissingLastItem.name;
                  depa.btReasonDriverNotAvailableLast = {
                    text: "<i class=\"fa fa-edit\"></i> " + depa.meetingLastMissingReasonName,
                    color: "custom"
                  };
                }

                if (depa.status === "Nouveau à programmer" || depa.status.endsWith("A reprogrammer")) {
                  if (depa.missingCount && depa.missingCount >= 3) {
                    depa.btScheduleDepa = {
                      text: '<i class="fa fa-ban"></i> Bloqué (' + depa.missingCount + "  RDV manqués)",
                      color: "custom-warning"
                    };
                  } else if (!depa.emailToUse && !depa.phoneToUse) {
                    depa.btScheduleDepa = {
                      text: '<i class="fa fa-calendar"></i> À planifier',
                      color: "custom-warning"
                    };
                  } else {
                    depa.btScheduleDepa = {
                      text: '<i class="fa fa-paper-plane"></i> Relancer',
                      color: "custom-warning"
                    };
                  }
                } else if (depa.status === "Annulé") {
                  depa.btScheduleDepa = {
                    text: '<i class="fa fa-ban"></i> Annulé',
                    color: "custom-info"
                  };
                  if (vm.isLvr) {
                    depa.btCancel = {
                      text: '<i class="fa fa-folder-open"></i> Réactiver',
                      color: "custom-warning"
                    };
                  }
                } else if (depa.status === "Programmé") {
                  depa.btScheduleDepa = {
                    text: '<i class="fa fa-edit"></i> Modifier le RDV',
                    color: "custom-success"
                  };
                } else if (depa.status === "Effectué") {
                  depa.btScheduleDepa = {
                    text: '<i class="fa fa-eye"></i> Fiche entretien',
                    color: "custom"
                  };
                }

                if (depa.status === "Programmé" && depa.slot && depa.slot.start && moment(depa.slot.start).isValid() || depa.status === "Effectué") {
                  depa.btForm = {
                    text: '<i class="fa fa-volume-control-phone"></i> Ouvrir',
                    color: "custom"
                  };
                }

                if (vm.isLvr) {
                  depa.btTrainingMode = {
                    text: '<i class="fa fa-volume-control-phone"></i> Entrainement',
                    color: "custom-success"
                  };
                }

                if (depa.status === "Programmé" && depa.slot && depa.slot.start && moment(depa.slot.start) <= today && vm.isLvr) {
                  depa.btNotAvailable = {
                    text: '<i class="fa fa-user-times"></i> Reporter',
                    color: "custom"
                  };
                }
                if (depa.status !== "Effectué" && depa.status !== "Annulé") {
                  depa.btCancel = {
                    text: '<i class="fa fa-ban"></i> Annuler',
                    color: "custom"
                  };
                }

                depa.btInfo = {
                  text: '<i class="fa fa-file"></i> Fiche récap.',
                  color: "custom"
                };
                depa.btDriverInfo = {
                  text: '<i class="fa fa-user"></i> Fiche conducteur',
                  color: "custom"
                };
                // Default:
                depa.dateDamage = null;
                depa.circumstance = "";
                depa.driver = { firstName: "?", lastName: "?" };
                typeOfAccidentData = void 0;


                if (damage.dateDamage) {
                  depa.dateDamage = damage.dateDamage;
                }
                depa.damageName = damage.name;
                depa.damageDocs = damage.docs;
                depa.damageDocsBilling = damage.docsBilling;

                _context26.next = 134;
                return CustomersService.getNameById($rootScope.$selectedCustomerId);

              case 134:
                depa.customerName = _context26.sent;


                depa.managerId = damage.managerId;
                _context26.next = 138;
                return UsersService.getById(damage.managerId);

              case 138:
                damageManager = _context26.sent;

                depa.damageManagerName = UsersService.getName(damageManager);
                depa.damageManagerEmail = damageManager.email;

                _context26.next = 143;
                return VehiclesService.getById(damage.vehicleId);

              case 143:
                depa.vehicle = _context26.sent;

                depa.vehicleName = depa.vehicle && depa.vehicle.plateNumber ? depa.vehicle.plateNumber : damage.externalVehicleName;

                depa.driverId = damage.driverId;
                _context26.next = 148;
                return UsersService.getById(damage.driverId);

              case 148:
                depa.driver = _context26.sent;


                depa.driverNbMissingDepas = depa.driver.nbMissingDepas;

                depa.typeOfAccident = damage.typeOfAccident;
                if (damage.typeOfAccident) {
                  typeOfAccidentData = vm.typeOfAccidentList.find(function (item) {
                    return item.value === damage.typeOfAccident;
                  });
                  if (typeOfAccidentData && typeOfAccidentData.data) {
                    depa.typeOfAccidentName = typeOfAccidentData.name.split(" (")[0];
                  } else {
                    depa.typeOfAccidentName = "???";
                  }
                }
                if (damage.circumstance) {
                  depa.circumstance = damage.circumstance;
                }

                blocked = depa.driver.endBlockDate && new Date(depa.driver.endBlockDate) >= new Date() ? true : false;

                depa.backgroundColor = blocked ? "rgb(249 89 145 / 50%)" : depa.backgroundColor;

                active = !depa.driver.endDate || new Date(depa.driver.endDate) >= new Date() ? true : false;

                depa.backgroundColor = !active ? "rgb(249, 161, 89, 0.5)" : depa.backgroundColor; // custom-warning 50%

                // Replace it by data from answers
                if (depa.answers && depa.answers.commentDetails) {
                  depa.circumstance = depa.answers.commentDetails;
                }
                if (depa.answers && depa.answers.commentSuggestions) {
                  depa.evitability = depa.answers.commentSuggestions;
                } else if (depa.answers && depa.answers.commentGlass) {
                  depa.evitability = depa.answers.commentGlass;
                }
                if (depa.answers && depa.answers.commentAdvices) {
                  depa.advices = depa.answers.commentAdvices;
                } else if (depa.answers && depa.answers.commentNotEvitable) {
                  depa.advices = depa.answers.commentNotEvitable;
                }
                depa.interviewEvaluation = depa.answers && depa.answers.interviewEvaluation ? depa.answers.interviewEvaluation + "/5" : "";
                depa.withInjuries = depa.answers && typeof depa.answers.withInjuries === "boolean" ? depa.answers.withInjuries === true ? "OUI" : "NON" : "";
                depa.withPsychologicalImpact = depa.answers && typeof depa.answers.withPsychologicalImpact === "boolean" ? depa.answers.withPsychologicalImpact === true ? "OUI" : "NON" : "";
                now = moment();
                dateDamage = moment(depa.dateDamage);


                depa.nbDays = now.diff(dateDamage, "days") + 1 + " jours";

                depa.driverName = "";
                depa.driverInternalNumber = "";
                depa.driverEmail = "";
                depa.driverCellularPhone = "";
                if (depa.driver) {
                  depa.driverName = UsersService.getName(depa.driver);
                  depa.driverInternalNumber = depa.driver.internalNumber;
                  depa.driverEmail = depa.driver.email;
                  depa.driverCellularPhone = depa.driver.cellularPhone;
                  depa.btUserInfo = {
                    text: "<i class=\"fa fa-file\"></i> " + depa.driverName,
                    color: "custom"
                  };
                }

                depa.groupName = "N.C.";

                if (!(depa.driver && depa.driver.groupsId && depa.driver.groupsId.length > 0)) {
                  _context26.next = 184;
                  break;
                }

                depa.groupName = "";
                _index2 = 0;

              case 175:
                if (!(_index2 < depa.driver.groupsId.length)) {
                  _context26.next = 184;
                  break;
                }

                groupId = depa.driver.groupsId[_index2];


                if (_index2 > 0) {
                  depa.groupName += " & ";
                }

                _context26.next = 180;
                return GroupsService.getNameById(groupId);

              case 180:
                depa.groupName += _context26.sent;

              case 181:
                _index2++;
                _context26.next = 175;
                break;

              case 184:
                manager = void 0;

                if (!(depa.driver && depa.driver.defaultManagerId)) {
                  _context26.next = 189;
                  break;
                }

                _context26.next = 188;
                return UsersService.getById(depa.driver.defaultManagerId);

              case 188:
                manager = _context26.sent;

              case 189:
                depa.managerName = "";
                depa.managerEmail = "";
                if (manager) {
                  depa.managerName = UsersService.getName(manager);
                  depa.managerEmail = manager.email;
                }
                if (vm.customer.sendManagerAct === true && depa.status === "Effectué" && depa.answers && depa.answers.typeOfAccidentV2 && depa.answers.typeOfAccidentV2[0] && ["circulation", "maneuver"].includes(depa.answers.typeOfAccidentV2[0])) {
                  if (depa.answers.typeContract && depa.answers.typeContract[0] && depa.answers.typeContract[0] === "relative") {
                    console.log("not sent managerial act if relative");
                  } else {
                    if (!depa.managerAct || !depa.managerAct.actDate) {
                      if (depa.managerActCancelled === true) {
                        depa.btCancelManagerAct = {
                          text: '<i class="fa fa-undo"></i> Réactiver l\'acte',
                          color: "custom-danger"
                        };
                      } else {
                        depa.btSendManagerAct = {
                          text: '<i class="fa fa-paper-plane"></i> Renvoyer le lien de l\'acte',
                          color: "custom"
                        };
                        depa.btCancelManagerAct = {
                          text: '<i class="fa fa-ban"></i> Annuler l\'acte',
                          color: "custom-danger"
                        };
                      }
                    }
                    if (depa.managerActCancelled !== true && managerActValidationShortIds.has(depa.shortId)) {
                      depa.btOpenManagerAct = {
                        text: '<i class="fa fa-external-link"></i> Ouvrir le lien de l\'acte',
                        color: "custom"
                      };
                    }
                  }
                }

                depa.isEvitable = depa.answers && typeof depa.answers.isEvitable === "boolean" ? depa.answers.isEvitable === true ? "OUI" : "NON" : "";
                depa.isEvitableLvr = depa.answers && typeof depa.answers.isEvitableLvr === "boolean" ? depa.answers.isEvitableLvr === true ? "OUI" : "NON" : "";
                // convert key to name:
                if (depa.answers && depa.answers.keywords && depa.answers.keywords.length > 0) {
                  depa.keywords = depa.answers.keywords.map(function (keyword) {
                    return "#" + keyword;
                  });
                }

                if (!(depa.slot && depa.slot.operatorId)) {
                  _context26.next = 204;
                  break;
                }

                _context26.next = 199;
                return OperatorsService.getById(depa.slot.operatorId);

              case 199:
                depa.operator = _context26.sent;
                _context26.next = 202;
                return OperatorsService.getNameById(depa.slot.operatorId);

              case 202:
                depa.operatorName = _context26.sent;


                if (depa.operator) {
                  vm.events.push({
                    title: depa.driverName + " avec " + depa.operatorName,
                    start: moment(depa.slot.start),
                    end: moment(depa.slot.end),
                    editable: false,
                    backgroundColor: depa.operator.calendarColor ? depa.operator.calendarColor : "#bccad6"
                  });
                }

              case 204:

                depa.statusName = depa.status.replace(" à programmer", "").replace("Conducteur non joignable - ", "");

                if (depa.status === "Effectué" && depa.answers && depa.answers.notRecognizeFacts) {
                  depa.statusName += " (mais n'a pas reconnu les faits)";
                } else if (depa.status === "Effectué" && depa.answers && depa.answers.dontRememberButRecognizeFacts) {
                  depa.statusName += " (ne se souvient pas mais reconnait les faits)";
                }

                // Manager act
                depa.managerActSent = depa.managerAct ? "OUI" : "";
                depa.managerActDate = depa.managerAct && depa.managerAct.actDate ? depa.managerAct.actDate : null;
                depa.managerActSigned = depa.managerAct && depa.managerAct.isSigned ? true : null;
                depa.managerActComment = depa.managerAct && depa.managerAct.comment ? depa.managerAct.comment : null;
                managerActMethod = depa.managerAct ? vm.managerActMethodList.find(function (item) {
                  return item.value === depa.managerAct.method;
                }) : null;

                depa.managerActMethodName = managerActMethod ? managerActMethod.name : null;

                rawData.push(depa);

              case 213:
                index++;
                _context26.next = 92;
                break;

              case 216:

                vm.rawData = rawData;
                vm.rawDataNotScheduled = rawData.filter(function (item) {
                  return item.status !== "Effectué" && item.status !== "Programmé" && item.status !== "Annulé";
                });
                vm.rawDataDone = rawData.filter(function (item) {
                  return item.status === "Effectué";
                });
                vm.rawDataManagerActTodo = rawData.filter(function (item) {
                  return item.btSendManagerAct;
                });

                Notiflix.Loading.remove();

                $timeout(function () {
                  vm.needToBeUpdate = true;
                  vm.needCalendarToBeUpdate = true;
                });
                _context26.next = 229;
                break;

              case 224:
                _context26.prev = 224;
                _context26.t3 = _context26["catch"](19);

                Notiflix.Loading.remove();
                Notiflix.Notify.failure("Impossible de charger les DEPA. Veuillez recharger les données.");
                $timeout(function () {
                  vm.rawData = [];
                  vm.rawDataDone = [];
                  vm.rawDataNotScheduled = [];
                  vm.rawDataManagerActTodo = [];
                  vm.events = [];
                  vm.needToBeUpdate = true;
                  vm.needCalendarToBeUpdate = true;
                });

              case 229:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this, [[19, 224], [29, 61], [40, 44, 48, 56], [49,, 51, 55], [73, 77, 81, 89], [82,, 84, 88]]);
      }));

      return function (_x24) {
        return _ref26.apply(this, arguments);
      };
    }();

    vm.refresh();

    vm.refreshCalendar = function () {
      $timeout(function () {
        vm.needCalendarToBeUpdate = true;
      }, 0);
    };

    vm.selectTab = function (tab) {
      vm.currentTab = tab;
      console.log("tab=", tab);
    };
  }
})();